// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fontsource/poppins/100.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fontsource/poppins/200.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fontsource/poppins/300.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fontsource/poppins/400.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fontsource/poppins/500.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fontsource/poppins/600.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fontsource/poppins/700.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fontsource/poppins/800.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fontsource/poppins/900.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Poppins, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  html {
    font-family: 'Poppins', system-ui, sans-serif;
  }
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-3 {
  inset: 0.75rem;
}
.inset-\\[10\\%\\] {
  inset: 10%;
}
.inset-\\[2\\%\\] {
  inset: 2%;
}
.inset-\\[3\\%\\] {
  inset: 3%;
}
.inset-\\[6\\%\\] {
  inset: 6%;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-x-1\\.5 {
  left: 0.375rem;
  right: 0.375rem;
}
.inset-x-3 {
  left: 0.75rem;
  right: 0.75rem;
}
.inset-x-5 {
  left: 1.25rem;
  right: 1.25rem;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-2 {
  bottom: -0.5rem;
}
.-bottom-20 {
  bottom: -5rem;
}
.-bottom-24 {
  bottom: -6rem;
}
.-bottom-\\[0\\.8rem\\] {
  bottom: -0.8rem;
}
.-bottom-\\[10\\%\\] {
  bottom: -10%;
}
.-bottom-\\[23px\\] {
  bottom: -23px;
}
.-end-0\\.5 {
  inset-inline-end: -0.125rem;
}
.-end-1\\.5 {
  inset-inline-end: -0.375rem;
}
.-end-10 {
  inset-inline-end: -2.5rem;
}
.-end-16 {
  inset-inline-end: -4rem;
}
.-end-2 {
  inset-inline-end: -0.5rem;
}
.-end-2\\.5 {
  inset-inline-end: -0.625rem;
}
.-end-3 {
  inset-inline-end: -0.75rem;
}
.-end-6 {
  inset-inline-end: -1.5rem;
}
.-end-\\[0\\.7rem\\] {
  inset-inline-end: -0.7rem;
}
.-left-1\\.5 {
  left: -0.375rem;
}
.-left-2\\.5 {
  left: -0.625rem;
}
.-left-24 {
  left: -6rem;
}
.-left-\\[10\\%\\] {
  left: -10%;
}
.-right-0\\.5 {
  right: -0.125rem;
}
.-right-10 {
  right: -2.5rem;
}
.-right-2 {
  right: -0.5rem;
}
.-right-24 {
  right: -6rem;
}
.-right-\\[10\\%\\] {
  right: -10%;
}
.-start-3 {
  inset-inline-start: -0.75rem;
}
.-start-8 {
  inset-inline-start: -2rem;
}
.-top-0\\.5 {
  top: -0.125rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-10 {
  top: -2.5rem;
}
.-top-16 {
  top: -4rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-2\\.5 {
  top: -0.625rem;
}
.-top-24 {
  top: -6rem;
}
.-top-3 {
  top: -0.75rem;
}
.-top-4 {
  top: -1rem;
}
.-top-6 {
  top: -1.5rem;
}
.-top-\\[0\\.8rem\\] {
  top: -0.8rem;
}
.-top-\\[10\\%\\] {
  top: -10%;
}
.-top-px {
  top: -1px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-1\\.5 {
  bottom: 0.375rem;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-16 {
  bottom: 4rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-2\\.5 {
  bottom: 0.625rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-7 {
  bottom: 1.75rem;
}
.bottom-8 {
  bottom: 2rem;
}
.bottom-\\[26\\%\\] {
  bottom: 26%;
}
.bottom-full {
  bottom: 100%;
}
.end-0 {
  inset-inline-end: 0px;
}
.end-1 {
  inset-inline-end: 0.25rem;
}
.end-1\\.5 {
  inset-inline-end: 0.375rem;
}
.end-2 {
  inset-inline-end: 0.5rem;
}
.end-2\\.5 {
  inset-inline-end: 0.625rem;
}
.end-3 {
  inset-inline-end: 0.75rem;
}
.end-3\\.5 {
  inset-inline-end: 0.875rem;
}
.end-4 {
  inset-inline-end: 1rem;
}
.end-5 {
  inset-inline-end: 1.25rem;
}
.end-6 {
  inset-inline-end: 1.5rem;
}
.end-\\[10\\%\\] {
  inset-inline-end: 10%;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-1\\/3 {
  left: 33.333333%;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-\\[16\\%\\] {
  left: 16%;
}
.left-\\[34\\%\\] {
  left: 34%;
}
.left-\\[4\\%\\] {
  left: 4%;
}
.left-\\[44\\%\\] {
  left: 44%;
}
.right-0 {
  right: 0px;
}
.right-4 {
  right: 1rem;
}
.right-\\[10\\%\\] {
  right: 10%;
}
.right-\\[10px\\] {
  right: 10px;
}
.right-\\[15\\%\\] {
  right: 15%;
}
.right-\\[2\\%\\] {
  right: 2%;
}
.right-\\[22\\%\\] {
  right: 22%;
}
.right-\\[4\\%\\] {
  right: 4%;
}
.start-0 {
  inset-inline-start: 0px;
}
.start-0\\.5 {
  inset-inline-start: 0.125rem;
}
.start-1 {
  inset-inline-start: 0.25rem;
}
.start-1\\/2 {
  inset-inline-start: 50%;
}
.start-10 {
  inset-inline-start: 2.5rem;
}
.start-2 {
  inset-inline-start: 0.5rem;
}
.start-2\\.5 {
  inset-inline-start: 0.625rem;
}
.start-3 {
  inset-inline-start: 0.75rem;
}
.start-3\\.5 {
  inset-inline-start: 0.875rem;
}
.start-4 {
  inset-inline-start: 1rem;
}
.start-6 {
  inset-inline-start: 1.5rem;
}
.start-7 {
  inset-inline-start: 1.75rem;
}
.start-\\[-4rem\\] {
  inset-inline-start: -4rem;
}
.start-\\[-50\\%\\] {
  inset-inline-start: -50%;
}
.start-\\[17px\\] {
  inset-inline-start: 17px;
}
.start-\\[3px\\] {
  inset-inline-start: 3px;
}
.start-\\[4px\\] {
  inset-inline-start: 4px;
}
.start-\\[5px\\] {
  inset-inline-start: 5px;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-12 {
  top: 3rem;
}
.top-16 {
  top: 4rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-20 {
  top: 5rem;
}
.top-24 {
  top: 6rem;
}
.top-28 {
  top: 7rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-6 {
  top: 1.5rem;
}
.top-8 {
  top: 2rem;
}
.top-9 {
  top: 2.25rem;
}
.top-\\[0\\.55rem\\] {
  top: 0.55rem;
}
.top-\\[1\\.15rem\\] {
  top: 1.15rem;
}
.top-\\[10\\%\\] {
  top: 10%;
}
.top-\\[14\\%\\] {
  top: 14%;
}
.top-\\[18\\%\\] {
  top: 18%;
}
.top-\\[18px\\] {
  top: 18px;
}
.top-\\[20\\%\\] {
  top: 20%;
}
.top-\\[22\\%\\] {
  top: 22%;
}
.top-\\[3px\\] {
  top: 3px;
}
.top-\\[4\\%\\] {
  top: 4%;
}
.top-\\[4\\.25rem\\] {
  top: 4.25rem;
}
.top-\\[4\\.75rem\\] {
  top: 4.75rem;
}
.top-\\[68px\\] {
  top: 68px;
}
.top-\\[7px\\] {
  top: 7px;
}
.top-\\[84px\\] {
  top: 84px;
}
.top-\\[max\\(0\\.75rem\\2c env\\(safe-area-inset-top\\)\\)\\] {
  top: max(0.75rem,env(safe-area-inset-top));
}
.top-\\[var\\(--shop-sticky-top\\2c 0px\\)\\] {
  top: var(--shop-sticky-top,0px);
}
.top-\\[var\\(--shops-sticky-top\\2c 0px\\)\\] {
  top: var(--shops-sticky-top,0px);
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.z-\\[10001\\] {
  z-index: 10001;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1050\\] {
  z-index: 1050;
}
.z-\\[1090\\] {
  z-index: 1090;
}
.z-\\[1100\\] {
  z-index: 1100;
}
.z-\\[110\\] {
  z-index: 110;
}
.z-\\[1200\\] {
  z-index: 1200;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[200\\] {
  z-index: 200;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[40\\] {
  z-index: 40;
}
.z-\\[450\\] {
  z-index: 450;
}
.z-\\[500\\] {
  z-index: 500;
}
.z-\\[5\\] {
  z-index: 5;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[900\\] {
  z-index: 900;
}
.z-\\[950\\] {
  z-index: 950;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-9 {
  order: 9;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-mt-0\\.5 {
  margin-top: -0.125rem;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.-mt-1\\.5 {
  margin-top: -0.375rem;
}
.-mt-14 {
  margin-top: -3.5rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.-mt-20 {
  margin-top: -5rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.me-1 {
  margin-inline-end: 0.25rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-auto {
  margin-right: auto;
}
.ms-0\\.5 {
  margin-inline-start: 0.125rem;
}
.ms-1 {
  margin-inline-start: 0.25rem;
}
.ms-1\\.5 {
  margin-inline-start: 0.375rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.ms-auto {
  margin-inline-start: auto;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.\\!flex {
  display: flex !important;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/10\\] {
  aspect-ratio: 16/10;
}
.aspect-\\[3\\/2\\] {
  aspect-ratio: 3/2;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.aspect-\\[5\\/4\\] {
  aspect-ratio: 5/4;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.\\!h-10 {
  height: 2.5rem !important;
}
.\\!h-11 {
  height: 2.75rem !important;
}
.\\!h-12 {
  height: 3rem !important;
}
.\\!h-4 {
  height: 1rem !important;
}
.\\!h-8 {
  height: 2rem !important;
}
.\\!h-9 {
  height: 2.25rem !important;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-1\\/2 {
  height: 50%;
}
.h-1\\/3 {
  height: 33.333333%;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-3\\/4 {
  height: 75%;
}
.h-3\\/5 {
  height: 60%;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-4\\/5 {
  height: 80%;
}
.h-40 {
  height: 10rem;
}
.h-44 {
  height: 11rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[124px\\] {
  height: 124px;
}
.h-\\[148px\\] {
  height: 148px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[190px\\] {
  height: 190px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[216px\\] {
  height: 216px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[3\\.4rem\\] {
  height: 3.4rem;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-\\[34\\%\\] {
  height: 34%;
}
.h-\\[340px\\] {
  height: 340px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[360px\\] {
  height: 360px;
}
.h-\\[380px\\] {
  height: 380px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[4\\.5rem\\] {
  height: 4.5rem;
}
.h-\\[40\\%\\] {
  height: 40%;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[50\\%\\] {
  height: 50%;
}
.h-\\[52px\\] {
  height: 52px;
}
.h-\\[64\\%\\] {
  height: 64%;
}
.h-\\[72\\%\\] {
  height: 72%;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[78\\%\\] {
  height: 78%;
}
.h-\\[80\\%\\] {
  height: 80%;
}
.h-\\[calc\\(100\\%\\+0\\.75rem\\)\\] {
  height: calc(100% + 0.75rem);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.max-h-28 {
  max-height: 7rem;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-44 {
  max-height: 11rem;
}
.max-h-52 {
  max-height: 13rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[340px\\] {
  max-height: 340px;
}
.max-h-\\[380px\\] {
  max-height: 380px;
}
.max-h-\\[420px\\] {
  max-height: 420px;
}
.max-h-\\[520px\\] {
  max-height: 520px;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[68vh\\] {
  max-height: 68vh;
}
.max-h-\\[72vh\\] {
  max-height: 72vh;
}
.max-h-\\[88vh\\] {
  max-height: 88vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[92vh\\] {
  max-height: 92vh;
}
.max-h-\\[94vh\\] {
  max-height: 94vh;
}
.max-h-\\[calc\\(100vh-6rem\\)\\] {
  max-height: calc(100vh - 6rem);
}
.max-h-\\[calc\\(100vh-7rem\\)\\] {
  max-height: calc(100vh - 7rem);
}
.max-h-\\[calc\\(100vh-8rem\\)\\] {
  max-height: calc(100vh - 8rem);
}
.max-h-\\[min\\(380px\\2c 60vh\\)\\] {
  max-height: min(380px,60vh);
}
.max-h-\\[min\\(400px\\2c 60vh\\)\\] {
  max-height: min(400px,60vh);
}
.max-h-\\[min\\(70vh\\2c 26rem\\)\\] {
  max-height: min(70vh,26rem);
}
.max-h-full {
  max-height: 100%;
}
.\\!min-h-0 {
  min-height: 0px !important;
}
.\\!min-h-10 {
  min-height: 2.5rem !important;
}
.\\!min-h-9 {
  min-height: 2.25rem !important;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-11 {
  min-height: 2.75rem;
}
.min-h-12 {
  min-height: 3rem;
}
.min-h-14 {
  min-height: 3.5rem;
}
.min-h-6 {
  min-height: 1.5rem;
}
.min-h-9 {
  min-height: 2.25rem;
}
.min-h-\\[10rem\\] {
  min-height: 10rem;
}
.min-h-\\[110px\\] {
  min-height: 110px;
}
.min-h-\\[170px\\] {
  min-height: 170px;
}
.min-h-\\[2\\.1rem\\] {
  min-height: 2.1rem;
}
.min-h-\\[2\\.25rem\\] {
  min-height: 2.25rem;
}
.min-h-\\[2\\.5rem\\] {
  min-height: 2.5rem;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[220px\\] {
  min-height: 220px;
}
.min-h-\\[260px\\] {
  min-height: 260px;
}
.min-h-\\[2rem\\] {
  min-height: 2rem;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[4rem\\] {
  min-height: 4rem;
}
.min-h-\\[5\\.5rem\\] {
  min-height: 5.5rem;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-1 {
  width: 0.25rem !important;
}
.\\!w-10 {
  width: 2.5rem !important;
}
.\\!w-11 {
  width: 2.75rem !important;
}
.\\!w-12 {
  width: 3rem !important;
}
.\\!w-8 {
  width: 2rem !important;
}
.\\!w-9 {
  width: 2.25rem !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-2\\/5 {
  width: 40%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-3\\/5 {
  width: 60%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[170px\\] {
  width: 170px;
}
.w-\\[17rem\\] {
  width: 17rem;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[200\\%\\] {
  width: 200%;
}
.w-\\[210px\\] {
  width: 210px;
}
.w-\\[22rem\\] {
  width: 22rem;
}
.w-\\[24\\%\\] {
  width: 24%;
}
.w-\\[28\\%\\] {
  width: 28%;
}
.w-\\[34px\\] {
  width: 34px;
}
.w-\\[38\\%\\] {
  width: 38%;
}
.w-\\[380px\\] {
  width: 380px;
}
.w-\\[3px\\] {
  width: 3px;
}
.w-\\[4\\.5rem\\] {
  width: 4.5rem;
}
.w-\\[42px\\] {
  width: 42px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[52px\\] {
  width: 52px;
}
.w-\\[58px\\] {
  width: 58px;
}
.w-\\[62\\%\\] {
  width: 62%;
}
.w-\\[64\\%\\] {
  width: 64%;
}
.w-\\[72\\%\\] {
  width: 72%;
}
.w-\\[76px\\] {
  width: 76px;
}
.w-\\[78\\%\\] {
  width: 78%;
}
.w-\\[8\\.75rem\\] {
  width: 8.75rem;
}
.w-\\[88\\%\\] {
  width: 88%;
}
.w-\\[min\\(20rem\\2c 88vw\\)\\] {
  width: min(20rem,88vw);
}
.w-\\[min\\(44rem\\2c calc\\(100vw-3rem\\)\\)\\] {
  width: min(44rem,calc(100vw - 3rem));
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.\\!min-w-11 {
  min-width: 2.75rem !important;
}
.\\!min-w-\\[2\\.5rem\\] {
  min-width: 2.5rem !important;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-6 {
  min-width: 1.5rem;
}
.min-w-\\[1\\.25rem\\] {
  min-width: 1.25rem;
}
.min-w-\\[1000px\\] {
  min-width: 1000px;
}
.min-w-\\[1020px\\] {
  min-width: 1020px;
}
.min-w-\\[1040px\\] {
  min-width: 1040px;
}
.min-w-\\[10rem\\] {
  min-width: 10rem;
}
.min-w-\\[110px\\] {
  min-width: 110px;
}
.min-w-\\[11rem\\] {
  min-width: 11rem;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[18px\\] {
  min-width: 18px;
}
.min-w-\\[2\\.5rem\\] {
  min-width: 2.5rem;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[20px\\] {
  min-width: 20px;
}
.min-w-\\[210px\\] {
  min-width: 210px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[22px\\] {
  min-width: 22px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[2px\\] {
  min-width: 2px;
}
.min-w-\\[2rem\\] {
  min-width: 2rem;
}
.min-w-\\[32px\\] {
  min-width: 32px;
}
.min-w-\\[3rem\\] {
  min-width: 3rem;
}
.min-w-\\[40px\\] {
  min-width: 40px;
}
.min-w-\\[42px\\] {
  min-width: 42px;
}
.min-w-\\[560px\\] {
  min-width: 560px;
}
.min-w-\\[56px\\] {
  min-width: 56px;
}
.min-w-\\[640px\\] {
  min-width: 640px;
}
.min-w-\\[720px\\] {
  min-width: 720px;
}
.min-w-\\[820px\\] {
  min-width: 820px;
}
.min-w-\\[860px\\] {
  min-width: 860px;
}
.min-w-\\[880px\\] {
  min-width: 880px;
}
.min-w-\\[900px\\] {
  min-width: 900px;
}
.min-w-\\[920px\\] {
  min-width: 920px;
}
.min-w-\\[960px\\] {
  min-width: 960px;
}
.min-w-\\[980px\\] {
  min-width: 980px;
}
.min-w-\\[9rem\\] {
  min-width: 9rem;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[10rem\\] {
  max-width: 10rem;
}
.max-w-\\[110px\\] {
  max-width: 110px;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[120rem\\] {
  max-width: 120rem;
}
.max-w-\\[130px\\] {
  max-width: 130px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[14rem\\] {
  max-width: 14rem;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[15rem\\] {
  max-width: 15rem;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[16rem\\] {
  max-width: 16rem;
}
.max-w-\\[170px\\] {
  max-width: 170px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[18rem\\] {
  max-width: 18rem;
}
.max-w-\\[190px\\] {
  max-width: 190px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-\\[260px\\] {
  max-width: 260px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[320px\\] {
  max-width: 320px;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-\\[62\\%\\] {
  max-width: 62%;
}
.max-w-\\[64px\\] {
  max-width: 64px;
}
.max-w-\\[65\\%\\] {
  max-width: 65%;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[88rem\\] {
  max-width: 88rem;
}
.max-w-\\[90px\\] {
  max-width: 90px;
}
.max-w-\\[90vw\\] {
  max-width: 90vw;
}
.max-w-\\[92vw\\] {
  max-width: 92vw;
}
.max-w-\\[94\\%\\] {
  max-width: 94%;
}
.max-w-\\[calc\\(100\\%-3rem\\)\\] {
  max-width: calc(100% - 3rem);
}
.max-w-\\[calc\\(100vw-2rem\\)\\] {
  max-width: calc(100vw - 2rem);
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-\\[1\\.6\\] {
  flex: 1.6 1;
}
.flex-\\[2\\] {
  flex: 2 1;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.basis-32 {
  flex-basis: 8rem;
}
.basis-60 {
  flex-basis: 15rem;
}
.border-collapse {
  border-collapse: collapse;
}
.border-separate {
  border-collapse: separate;
}
.border-spacing-0 {
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-left {
  transform-origin: left;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2 {
  --tw-translate-x: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-3 {
  --tw-translate-y: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-9 {
  --tw-translate-x: 2.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[26px\\] {
  --tw-translate-x: 26px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-px {
  --tw-translate-x: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1 {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2 {
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4 {
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-50 {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu {
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-\\[spin_1\\.5s_linear_infinite\\] {
  animation: spin 1.5s linear infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-zoom-in {
  cursor: zoom-in;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-start {
  scroll-snap-align: start;
}
.scroll-mt-20 {
  scroll-margin-top: 5rem;
}
.scroll-mt-24 {
  scroll-margin-top: 6rem;
}
.scroll-mt-28 {
  scroll-margin-top: 7rem;
}
.scroll-mt-36 {
  scroll-margin-top: 9rem;
}
.scroll-mt-40 {
  scroll-margin-top: 10rem;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-\\[1\\.6fr_1fr\\] {
  grid-template-columns: 1.6fr 1fr;
}
.grid-rows-\\[0fr\\] {
  grid-template-rows: 0fr;
}
.grid-rows-\\[1fr\\] {
  grid-template-rows: 1fr;
}
.\\!flex-row {
  flex-direction: row !important;
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.content-start {
  align-content: flex-start;
}
.\\!items-start {
  align-items: flex-start !important;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.\\!justify-start {
  justify-content: flex-start !important;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.\\!justify-between {
  justify-content: space-between !important;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.\\!gap-1 {
  gap: 0.25rem !important;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[2px\\] {
  gap: 2px;
}
.gap-\\[3px\\] {
  gap: 3px;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-12 {
  column-gap: 3rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-0 {
  row-gap: 0px;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.-space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(-0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(-0.25rem * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-7 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(2px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(2px * var(--tw-divide-y-reverse));
}
.divide-\\[color\\:var\\(--line\\)\\] > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--line);
}
.divide-\\[color\\:var\\(--nb-line\\)\\] > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--nb-line);
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity));
}
.divide-gray-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-divide-opacity));
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.self-stretch {
  align-self: stretch;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-x-clip {
  overflow-x: clip;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-2xl {
  border-radius: 1rem !important;
}
.\\!rounded-3xl {
  border-radius: 1.5rem !important;
}
.\\!rounded-\\[20px\\] {
  border-radius: 20px !important;
}
.\\!rounded-\\[26px\\] {
  border-radius: 26px !important;
}
.\\!rounded-\\[36px\\] {
  border-radius: 36px !important;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.\\!rounded-lg {
  border-radius: 0.5rem !important;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.\\!rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[1\\.25rem\\] {
  border-radius: 1.25rem;
}
.rounded-\\[1\\.5rem\\] {
  border-radius: 1.5rem;
}
.rounded-\\[1\\.75rem\\] {
  border-radius: 1.75rem;
}
.rounded-\\[2\\.5rem\\] {
  border-radius: 2.5rem;
}
.rounded-\\[2rem\\] {
  border-radius: 2rem;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.\\!rounded-b-none {
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-s-\\[1\\.45rem\\] {
  border-start-start-radius: 1.45rem;
  border-end-start-radius: 1.45rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-\\[1\\.75rem\\] {
  border-top-left-radius: 1.75rem;
  border-top-right-radius: 1.75rem;
}
.rounded-t-\\[2\\.5rem\\] {
  border-top-left-radius: 2.5rem;
  border-top-right-radius: 2.5rem;
}
.rounded-t-\\[2rem\\] {
  border-top-left-radius: 2rem;
  border-top-right-radius: 2rem;
}
.rounded-t-sm {
  border-top-left-radius: 0.125rem;
  border-top-right-radius: 0.125rem;
}
.rounded-bl-none {
  border-bottom-left-radius: 0px;
}
.rounded-br-none {
  border-bottom-right-radius: 0px;
}
.rounded-ee-xl {
  border-end-end-radius: 0.75rem;
}
.\\!border {
  border-width: 1px !important;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-\\[3px\\] {
  border-width: 3px;
}
.border-x-2 {
  border-left-width: 2px;
  border-right-width: 2px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-y-0 {
  border-top-width: 0px;
  border-bottom-width: 0px;
}
.border-y-2 {
  border-top-width: 2px;
  border-bottom-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-b-\\[3px\\] {
  border-bottom-width: 3px;
}
.border-e {
  border-inline-end-width: 1px;
}
.border-e-0 {
  border-inline-end-width: 0px;
}
.border-e-2 {
  border-inline-end-width: 2px;
}
.border-e-\\[3px\\] {
  border-inline-end-width: 3px;
}
.border-l {
  border-left-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-s-2 {
  border-inline-start-width: 2px;
}
.border-s-4 {
  border-inline-start-width: 4px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-t-\\[3px\\] {
  border-top-width: 3px;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.\\!border-\\[color\\:var\\(--line\\)\\] {
  border-color: var(--line) !important;
}
.\\!border-current {
  border-color: currentColor !important;
}
.\\!border-red-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity)) !important;
}
.\\!border-rose-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(253 164 175 / var(--tw-border-opacity)) !important;
}
.\\!border-rose-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(251 113 133 / var(--tw-border-opacity)) !important;
}
.\\!border-rose-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 63 94 / var(--tw-border-opacity)) !important;
}
.\\!border-transparent {
  border-color: transparent !important;
}
.border-\\[\\#39ff88\\] {
  --tw-border-opacity: 1;
  border-color: rgb(57 255 136 / var(--tw-border-opacity));
}
.border-\\[\\#39ff88\\]\\/40 {
  border-color: rgb(57 255 136 / 0.4);
}
.border-\\[\\#3d3d3d\\] {
  --tw-border-opacity: 1;
  border-color: rgb(61 61 61 / var(--tw-border-opacity));
}
.border-\\[color\\:var\\(--bd\\)\\] {
  border-color: var(--bd);
}
.border-\\[color\\:var\\(--err\\)\\] {
  border-color: var(--err);
}
.border-\\[color\\:var\\(--ink\\)\\] {
  border-color: var(--ink);
}
.border-\\[color\\:var\\(--line\\)\\] {
  border-color: var(--line);
}
.border-\\[color\\:var\\(--line2\\)\\] {
  border-color: var(--line2);
}
.border-\\[color\\:var\\(--mu\\)\\] {
  border-color: var(--mu);
}
.border-\\[color\\:var\\(--nb-line\\)\\] {
  border-color: var(--nb-line);
}
.border-\\[color\\:var\\(--nb-line2\\)\\] {
  border-color: var(--nb-line2);
}
.border-\\[color\\:var\\(--nc-accent\\)\\] {
  border-color: var(--nc-accent);
}
.border-\\[color\\:var\\(--nc-line\\)\\] {
  border-color: var(--nc-line);
}
.border-\\[color\\:var\\(--panel\\)\\] {
  border-color: var(--panel);
}
.border-\\[color\\:var\\(--tk-line\\)\\] {
  border-color: var(--tk-line);
}
.border-\\[var\\(--line\\)\\] {
  border-color: var(--line);
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-black\\/10 {
  border-color: rgb(0 0 0 / 0.1);
}
.border-current {
  border-color: currentColor;
}
.border-cyan-200 {
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity));
}
.border-emerald-100 {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity));
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity));
}
.border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity));
}
.border-emerald-300\\/70 {
  border-color: rgb(110 231 183 / 0.7);
}
.border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity));
}
.border-emerald-400\\/40 {
  border-color: rgb(52 211 153 / 0.4);
}
.border-emerald-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 253 245 / var(--tw-border-opacity));
}
.border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.border-emerald-500\\/25 {
  border-color: rgb(16 185 129 / 0.25);
}
.border-emerald-600 {
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity));
}
.border-emerald-600\\/30 {
  border-color: rgb(5 150 105 / 0.3);
}
.border-emerald-700 {
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / var(--tw-border-opacity));
}
.border-emerald-900 {
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / var(--tw-border-opacity));
}
.border-emerald-900\\/20 {
  border-color: rgb(6 78 59 / 0.2);
}
.border-emerald-900\\/30 {
  border-color: rgb(6 78 59 / 0.3);
}
.border-emerald-900\\/70 {
  border-color: rgb(6 78 59 / 0.7);
}
.border-emerald-950 {
  --tw-border-opacity: 1;
  border-color: rgb(2 44 34 / var(--tw-border-opacity));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}
.border-gray-700\\/70 {
  border-color: rgb(55 65 81 / 0.7);
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}
.border-gray-950 {
  --tw-border-opacity: 1;
  border-color: rgb(3 7 18 / var(--tw-border-opacity));
}
.border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity));
}
.border-indigo-600 {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity));
}
.border-lime-200 {
  --tw-border-opacity: 1;
  border-color: rgb(217 249 157 / var(--tw-border-opacity));
}
.border-neutral-600 {
  --tw-border-opacity: 1;
  border-color: rgb(82 82 82 / var(--tw-border-opacity));
}
.border-neutral-700 {
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / var(--tw-border-opacity));
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity));
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.border-red-900\\/60 {
  border-color: rgb(127 29 29 / 0.6);
}
.border-rose-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity));
}
.border-rose-400\\/30 {
  border-color: rgb(251 113 133 / 0.3);
}
.border-rose-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity));
}
.border-rose-500\\/30 {
  border-color: rgb(244 63 94 / 0.3);
}
.border-sky-200 {
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.border-teal-200 {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-violet-200 {
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15 {
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/40 {
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/60 {
  border-color: rgb(255 255 255 / 0.6);
}
.border-t-transparent {
  border-top-color: transparent;
}
.\\!bg-\\[color\\:var\\(--nb-gray\\)\\] {
  background-color: var(--nb-gray) !important;
}
.\\!bg-\\[color\\:var\\(--nc-card\\)\\] {
  background-color: var(--nc-card) !important;
}
.\\!bg-\\[color\\:var\\(--nc-ink\\)\\] {
  background-color: var(--nc-ink) !important;
}
.\\!bg-\\[color\\:var\\(--soft\\)\\] {
  background-color: var(--soft) !important;
}
.\\!bg-\\[var\\(--pg-ink\\)\\] {
  background-color: var(--pg-ink) !important;
}
.\\!bg-amber-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity)) !important;
}
.\\!bg-black\\/5 {
  background-color: rgb(0 0 0 / 0.05) !important;
}
.\\!bg-emerald-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity)) !important;
}
.\\!bg-gray-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity)) !important;
}
.\\!bg-gray-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity)) !important;
}
.\\!bg-rose-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#04120b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(4 18 11 / var(--tw-bg-opacity));
}
.bg-\\[\\#04261a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(4 38 26 / var(--tw-bg-opacity));
}
.bg-\\[\\#0e0e0e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(14 14 14 / var(--tw-bg-opacity));
}
.bg-\\[\\#141414\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 20 20 / var(--tw-bg-opacity));
}
.bg-\\[\\#1a1a1a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 26 / var(--tw-bg-opacity));
}
.bg-\\[\\#1e1e1e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity));
}
.bg-\\[\\#1f3a5a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(31 58 90 / var(--tw-bg-opacity));
}
.bg-\\[\\#232625\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(35 38 37 / var(--tw-bg-opacity));
}
.bg-\\[\\#243f5f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(36 63 95 / var(--tw-bg-opacity));
}
.bg-\\[\\#262626\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity));
}
.bg-\\[\\#2a2a2a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(42 42 42 / var(--tw-bg-opacity));
}
.bg-\\[\\#39ff88\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(57 255 136 / var(--tw-bg-opacity));
}
.bg-\\[\\#f6f2ee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 242 238 / var(--tw-bg-opacity));
}
.bg-\\[\\#fafafa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-\\[color\\:var\\(--acc\\)\\] {
  background-color: var(--acc);
}
.bg-\\[color\\:var\\(--bar\\)\\] {
  background-color: var(--bar);
}
.bg-\\[color\\:var\\(--bd\\)\\] {
  background-color: var(--bd);
}
.bg-\\[color\\:var\\(--bg\\)\\] {
  background-color: var(--bg);
}
.bg-\\[color\\:var\\(--card\\)\\] {
  background-color: var(--card);
}
.bg-\\[color\\:var\\(--chip\\)\\] {
  background-color: var(--chip);
}
.bg-\\[color\\:var\\(--err\\)\\] {
  background-color: var(--err);
}
.bg-\\[color\\:var\\(--field\\)\\] {
  background-color: var(--field);
}
.bg-\\[color\\:var\\(--fld\\)\\] {
  background-color: var(--fld);
}
.bg-\\[color\\:var\\(--g-accent\\)\\] {
  background-color: var(--g-accent);
}
.bg-\\[color\\:var\\(--hist\\)\\] {
  background-color: var(--hist);
}
.bg-\\[color\\:var\\(--hov\\)\\] {
  background-color: var(--hov);
}
.bg-\\[color\\:var\\(--img\\)\\] {
  background-color: var(--img);
}
.bg-\\[color\\:var\\(--line\\)\\] {
  background-color: var(--line);
}
.bg-\\[color\\:var\\(--line2\\)\\] {
  background-color: var(--line2);
}
.bg-\\[color\\:var\\(--media\\)\\] {
  background-color: var(--media);
}
.bg-\\[color\\:var\\(--nb-accent\\)\\] {
  background-color: var(--nb-accent);
}
.bg-\\[color\\:var\\(--nb-bg\\)\\] {
  background-color: var(--nb-bg);
}
.bg-\\[color\\:var\\(--nb-btn\\)\\] {
  background-color: var(--nb-btn);
}
.bg-\\[color\\:var\\(--nb-card\\)\\] {
  background-color: var(--nb-card);
}
.bg-\\[color\\:var\\(--nb-scrim\\)\\] {
  background-color: var(--nb-scrim);
}
.bg-\\[color\\:var\\(--nc-accent\\)\\] {
  background-color: var(--nc-accent);
}
.bg-\\[color\\:var\\(--overlay\\)\\] {
  background-color: var(--overlay);
}
.bg-\\[color\\:var\\(--page\\)\\] {
  background-color: var(--page);
}
.bg-\\[color\\:var\\(--panel\\)\\] {
  background-color: var(--panel);
}
.bg-\\[color\\:var\\(--pg\\)\\] {
  background-color: var(--pg);
}
.bg-\\[color\\:var\\(--pg-accent\\)\\] {
  background-color: var(--pg-accent);
}
.bg-\\[color\\:var\\(--pill\\)\\] {
  background-color: var(--pill);
}
.bg-\\[color\\:var\\(--sf\\)\\] {
  background-color: var(--sf);
}
.bg-\\[color\\:var\\(--sf2\\)\\] {
  background-color: var(--sf2);
}
.bg-\\[color\\:var\\(--soft\\)\\] {
  background-color: var(--soft);
}
.bg-\\[color\\:var\\(--tag\\)\\] {
  background-color: var(--tag);
}
.bg-\\[color\\:var\\(--tint\\)\\] {
  background-color: var(--tint);
}
.bg-\\[var\\(--card\\)\\] {
  background-color: var(--card);
}
.bg-\\[var\\(--pg-accent\\)\\] {
  background-color: var(--pg-accent);
}
.bg-\\[var\\(--pg-btn\\)\\] {
  background-color: var(--pg-btn);
}
.bg-\\[var\\(--pm-btn\\)\\] {
  background-color: var(--pm-btn);
}
.bg-\\[var\\(--pm-gray\\)\\] {
  background-color: var(--pm-gray);
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.bg-amber-500\\/10 {
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/15 {
  background-color: rgb(245 158 11 / 0.15);
}
.bg-amber-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/25 {
  background-color: rgb(0 0 0 / 0.25);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/5 {
  background-color: rgb(0 0 0 / 0.05);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/55 {
  background-color: rgb(0 0 0 / 0.55);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-current {
  background-color: currentColor;
}
.bg-emerald-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity));
}
.bg-emerald-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity));
}
.bg-emerald-300\\/10 {
  background-color: rgb(110 231 183 / 0.1);
}
.bg-emerald-300\\/40 {
  background-color: rgb(110 231 183 / 0.4);
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity));
}
.bg-emerald-400\\/10 {
  background-color: rgb(52 211 153 / 0.1);
}
.bg-emerald-400\\/20 {
  background-color: rgb(52 211 153 / 0.2);
}
.bg-emerald-400\\/60 {
  background-color: rgb(52 211 153 / 0.6);
}
.bg-emerald-400\\/80 {
  background-color: rgb(52 211 153 / 0.8);
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity));
}
.bg-emerald-50\\/50 {
  background-color: rgb(236 253 245 / 0.5);
}
.bg-emerald-50\\/60 {
  background-color: rgb(236 253 245 / 0.6);
}
.bg-emerald-50\\/70 {
  background-color: rgb(236 253 245 / 0.7);
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
.bg-emerald-500\\/10 {
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/15 {
  background-color: rgb(16 185 129 / 0.15);
}
.bg-emerald-500\\/20 {
  background-color: rgb(16 185 129 / 0.2);
}
.bg-emerald-500\\/5 {
  background-color: rgb(16 185 129 / 0.05);
}
.bg-emerald-500\\/70 {
  background-color: rgb(16 185 129 / 0.7);
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity));
}
.bg-emerald-600\\/10 {
  background-color: rgb(5 150 105 / 0.1);
}
.bg-emerald-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity));
}
.bg-emerald-900\\/25 {
  background-color: rgb(6 78 59 / 0.25);
}
.bg-emerald-900\\/30 {
  background-color: rgb(6 78 59 / 0.3);
}
.bg-emerald-900\\/50 {
  background-color: rgb(6 78 59 / 0.5);
}
.bg-emerald-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 44 34 / var(--tw-bg-opacity));
}
.bg-emerald-950\\/85 {
  background-color: rgb(2 44 34 / 0.85);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-200\\/70 {
  background-color: rgb(229 231 235 / 0.7);
}
.bg-gray-200\\/80 {
  background-color: rgb(229 231 235 / 0.8);
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-50\\/50 {
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-50\\/90 {
  background-color: rgb(249 250 251 / 0.9);
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.bg-gray-700\\/40 {
  background-color: rgb(55 65 81 / 0.4);
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.bg-gray-800\\/40 {
  background-color: rgb(31 41 55 / 0.4);
}
.bg-gray-800\\/70 {
  background-color: rgb(31 41 55 / 0.7);
}
.bg-gray-800\\/90 {
  background-color: rgb(31 41 55 / 0.9);
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.bg-gray-900\\/40 {
  background-color: rgb(17 24 39 / 0.4);
}
.bg-gray-900\\/50 {
  background-color: rgb(17 24 39 / 0.5);
}
.bg-gray-900\\/60 {
  background-color: rgb(17 24 39 / 0.6);
}
.bg-gray-900\\/70 {
  background-color: rgb(17 24 39 / 0.7);
}
.bg-gray-900\\/80 {
  background-color: rgb(17 24 39 / 0.8);
}
.bg-gray-900\\/85 {
  background-color: rgb(17 24 39 / 0.85);
}
.bg-gray-900\\/90 {
  background-color: rgb(17 24 39 / 0.9);
}
.bg-gray-900\\/95 {
  background-color: rgb(17 24 39 / 0.95);
}
.bg-gray-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}
.bg-lime-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity));
}
.bg-lime-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity));
}
.bg-lime-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity));
}
.bg-lime-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity));
}
.bg-lime-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(54 83 20 / var(--tw-bg-opacity));
}
.bg-neutral-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 82 / var(--tw-bg-opacity));
}
.bg-neutral-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity));
}
.bg-orange-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity));
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-red-500\\/15 {
  background-color: rgb(239 68 68 / 0.15);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-rose-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity));
}
.bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity));
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity));
}
.bg-rose-500\\/10 {
  background-color: rgb(244 63 94 / 0.1);
}
.bg-rose-500\\/15 {
  background-color: rgb(244 63 94 / 0.15);
}
.bg-rose-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity));
}
.bg-sky-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity));
}
.bg-sky-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity));
}
.bg-sky-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity));
}
.bg-teal-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity));
}
.bg-teal-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(19 78 74 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-violet-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity));
}
.bg-violet-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/25 {
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/35 {
  background-color: rgb(255 255 255 / 0.35);
}
.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}
.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.bg-\\[radial-gradient\\(circle_at_center\\2c _\\#f1f5f9_1px\\2c _transparent_1px\\)\\] {
  background-image: radial-gradient(circle at center, #f1f5f9 1px, transparent 1px);
}
.bg-\\[radial-gradient\\(closest-side\\2c rgba\\(110\\2c 231\\2c 183\\2c 0\\.5\\)\\2c transparent\\)\\] {
  background-image: radial-gradient(closest-side,rgba(110,231,183,0.5),transparent);
}
.bg-\\[radial-gradient\\(closest-side\\2c rgba\\(16\\2c 185\\2c 129\\2c 0\\.25\\)\\2c transparent\\)\\] {
  background-image: radial-gradient(closest-side,rgba(16,185,129,0.25),transparent);
}
.bg-\\[radial-gradient\\(closest-side\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.08\\)\\2c transparent\\)\\] {
  background-image: radial-gradient(closest-side,rgba(255,255,255,0.08),transparent);
}
.bg-\\[radial-gradient\\(closest-side\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.14\\)\\2c transparent\\)\\] {
  background-image: radial-gradient(closest-side,rgba(255,255,255,0.14),transparent);
}
.bg-\\[radial-gradient\\(closest-side\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.35\\)\\2c transparent\\)\\] {
  background-image: radial-gradient(closest-side,rgba(255,255,255,0.35),transparent);
}
.bg-\\[radial-gradient\\(closest-side\\2c rgba\\(59\\2c 130\\2c 246\\2c 0\\.14\\)\\2c transparent\\)\\] {
  background-image: radial-gradient(closest-side,rgba(59,130,246,0.14),transparent);
}
.bg-\\[radial-gradient\\(closest-side\\2c rgba\\(99\\2c 102\\2c 241\\2c 0\\.14\\)\\2c transparent\\)\\] {
  background-image: radial-gradient(closest-side,rgba(99,102,241,0.14),transparent);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.\\!from-emerald-700 {
  --tw-gradient-from: #047857 var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(4 120 87 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-\\[color\\:var\\(--acc-hi\\)\\] {
  --tw-gradient-from: var(--acc-hi) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[color\\:var\\(--g1\\)\\] {
  --tw-gradient-from: var(--g1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[color\\:var\\(--g3\\)\\] {
  --tw-gradient-from: var(--g3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-300 {
  --tw-gradient-from: #fcd34d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(252 211 77 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-400 {
  --tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-400\\/20 {
  --tw-gradient-from: rgb(251 191 36 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50 {
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/30 {
  --tw-gradient-from: rgb(0 0 0 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-400\\/20 {
  --tw-gradient-from: rgb(34 211 238 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 211 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-50 {
  --tw-gradient-from: #ecfeff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 254 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-300 {
  --tw-gradient-from: #6ee7b7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(110 231 183 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-400 {
  --tw-gradient-from: #34d399 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-400\\/20 {
  --tw-gradient-from: rgb(52 211 153 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50 {
  --tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500 {
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-600 {
  --tw-gradient-from: #059669 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 150 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-900 {
  --tw-gradient-from: #064e3b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 78 59 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-950 {
  --tw-gradient-from: #022c22 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 44 34 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-400\\/20 {
  --tw-gradient-from: rgb(129 140 248 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50 {
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-400\\/20 {
  --tw-gradient-from: rgb(251 146 60 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-50 {
  --tw-gradient-from: #fff7ed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-300 {
  --tw-gradient-from: #fda4af var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 164 175 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-400 {
  --tw-gradient-from: #fb7185 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 113 133 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-400\\/20 {
  --tw-gradient-from: rgb(251 113 133 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 113 133 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-50 {
  --tw-gradient-from: #fff1f2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 241 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-500 {
  --tw-gradient-from: #f43f5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-300 {
  --tw-gradient-from: #7dd3fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(125 211 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-400 {
  --tw-gradient-from: #38bdf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(56 189 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-400\\/20 {
  --tw-gradient-from: rgb(56 189 248 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(56 189 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-50 {
  --tw-gradient-from: #f0f9ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 249 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500 {
  --tw-gradient-from: #0ea5e9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-400\\/20 {
  --tw-gradient-from: rgb(148 163 184 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(148 163 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50 {
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-300 {
  --tw-gradient-from: #5eead4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(94 234 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-400\\/20 {
  --tw-gradient-from: rgb(45 212 191 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(45 212 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-50 {
  --tw-gradient-from: #f0fdfa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-300 {
  --tw-gradient-from: #c4b5fd var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(196 181 253 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-400\\/20 {
  --tw-gradient-from: rgb(167 139 250 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(167 139 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-50 {
  --tw-gradient-from: #f5f3ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 243 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500 {
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/25 {
  --tw-gradient-from: rgb(255 255 255 / 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-emerald-500 {
  --tw-gradient-to: rgb(16 185 129 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #10b981 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-emerald-600 {
  --tw-gradient-to: rgb(5 150 105 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #059669 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-emerald-800 {
  --tw-gradient-to: rgb(6 95 70 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #065f46 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-emerald-950 {
  --tw-gradient-to: rgb(2 44 34 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #022c22 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-900 {
  --tw-gradient-to: rgb(17 24 39 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #111827 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-rose-500 {
  --tw-gradient-to: rgb(244 63 94 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f43f5e var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.\\!to-emerald-700 {
  --tw-gradient-to: #047857 var(--tw-gradient-to-position) !important;
}
.to-\\[\\#030a06\\] {
  --tw-gradient-to: #030a06 var(--tw-gradient-to-position);
}
.to-\\[color\\:var\\(--acc\\)\\] {
  --tw-gradient-to: var(--acc) var(--tw-gradient-to-position);
}
.to-\\[color\\:var\\(--card\\)\\] {
  --tw-gradient-to: var(--card) var(--tw-gradient-to-position);
}
.to-\\[color\\:var\\(--g2\\)\\] {
  --tw-gradient-to: var(--g2) var(--tw-gradient-to-position);
}
.to-amber-100 {
  --tw-gradient-to: #fef3c7 var(--tw-gradient-to-position);
}
.to-amber-400\\/5 {
  --tw-gradient-to: rgb(251 191 36 / 0.05) var(--tw-gradient-to-position);
}
.to-amber-500 {
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
}
.to-amber-600 {
  --tw-gradient-to: #d97706 var(--tw-gradient-to-position);
}
.to-blue-700 {
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-cyan-100 {
  --tw-gradient-to: #cffafe var(--tw-gradient-to-position);
}
.to-cyan-400\\/5 {
  --tw-gradient-to: rgb(34 211 238 / 0.05) var(--tw-gradient-to-position);
}
.to-cyan-600 {
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-emerald-100 {
  --tw-gradient-to: #d1fae5 var(--tw-gradient-to-position);
}
.to-emerald-400\\/5 {
  --tw-gradient-to: rgb(52 211 153 / 0.05) var(--tw-gradient-to-position);
}
.to-emerald-600 {
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-emerald-700 {
  --tw-gradient-to: #047857 var(--tw-gradient-to-position);
}
.to-emerald-800 {
  --tw-gradient-to: #065f46 var(--tw-gradient-to-position);
}
.to-emerald-900 {
  --tw-gradient-to: #064e3b var(--tw-gradient-to-position);
}
.to-emerald-950 {
  --tw-gradient-to: #022c22 var(--tw-gradient-to-position);
}
.to-fuchsia-600 {
  --tw-gradient-to: #c026d3 var(--tw-gradient-to-position);
}
.to-gray-900 {
  --tw-gradient-to: #111827 var(--tw-gradient-to-position);
}
.to-gray-950 {
  --tw-gradient-to: #030712 var(--tw-gradient-to-position);
}
.to-indigo-100 {
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
.to-indigo-400\\/5 {
  --tw-gradient-to: rgb(129 140 248 / 0.05) var(--tw-gradient-to-position);
}
.to-orange-100 {
  --tw-gradient-to: #ffedd5 var(--tw-gradient-to-position);
}
.to-orange-400\\/5 {
  --tw-gradient-to: rgb(251 146 60 / 0.05) var(--tw-gradient-to-position);
}
.to-orange-500 {
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-rose-100 {
  --tw-gradient-to: #ffe4e6 var(--tw-gradient-to-position);
}
.to-rose-400\\/5 {
  --tw-gradient-to: rgb(251 113 133 / 0.05) var(--tw-gradient-to-position);
}
.to-rose-500 {
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.to-rose-600 {
  --tw-gradient-to: #e11d48 var(--tw-gradient-to-position);
}
.to-sky-100 {
  --tw-gradient-to: #e0f2fe var(--tw-gradient-to-position);
}
.to-sky-400\\/5 {
  --tw-gradient-to: rgb(56 189 248 / 0.05) var(--tw-gradient-to-position);
}
.to-sky-600 {
  --tw-gradient-to: #0284c7 var(--tw-gradient-to-position);
}
.to-slate-200 {
  --tw-gradient-to: #e2e8f0 var(--tw-gradient-to-position);
}
.to-slate-400\\/5 {
  --tw-gradient-to: rgb(148 163 184 / 0.05) var(--tw-gradient-to-position);
}
.to-teal-100 {
  --tw-gradient-to: #ccfbf1 var(--tw-gradient-to-position);
}
.to-teal-300 {
  --tw-gradient-to: #5eead4 var(--tw-gradient-to-position);
}
.to-teal-400\\/5 {
  --tw-gradient-to: rgb(45 212 191 / 0.05) var(--tw-gradient-to-position);
}
.to-teal-500 {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-teal-600 {
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-violet-100 {
  --tw-gradient-to: #ede9fe var(--tw-gradient-to-position);
}
.to-violet-400\\/5 {
  --tw-gradient-to: rgb(167 139 250 / 0.05) var(--tw-gradient-to-position);
}
.to-violet-600 {
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}
.to-white\\/5 {
  --tw-gradient-to: rgb(255 255 255 / 0.05) var(--tw-gradient-to-position);
}
.bg-\\[size\\:32px_32px\\] {
  background-size: 32px 32px;
}
.fill-\\[color\\:var\\(--acc\\)\\] {
  fill: var(--acc);
}
.fill-\\[color\\:var\\(--card\\)\\] {
  fill: var(--card);
}
.fill-\\[color\\:var\\(--field\\)\\] {
  fill: var(--field);
}
.fill-\\[color\\:var\\(--ink\\)\\] {
  fill: var(--ink);
}
.fill-\\[color\\:var\\(--soft\\)\\] {
  fill: var(--soft);
}
.fill-amber-400 {
  fill: #fbbf24;
}
.fill-black\\/5 {
  fill: rgb(0 0 0 / 0.05);
}
.fill-current {
  fill: currentColor;
}
.fill-emerald-50 {
  fill: #ecfdf5;
}
.fill-emerald-500 {
  fill: #10b981;
}
.fill-emerald-500\\/15 {
  fill: rgb(16 185 129 / 0.15);
}
.fill-emerald-500\\/50 {
  fill: rgb(16 185 129 / 0.5);
}
.fill-gray-100 {
  fill: #f3f4f6;
}
.fill-gray-200 {
  fill: #e5e7eb;
}
.fill-gray-300 {
  fill: #d1d5db;
}
.fill-none {
  fill: none;
}
.fill-white {
  fill: #fff;
}
.stroke-\\[color\\:var\\(--ink\\)\\] {
  stroke: var(--ink);
}
.stroke-emerald-500 {
  stroke: #10b981;
}
.stroke-emerald-600 {
  stroke: #059669;
}
.stroke-gray-300 {
  stroke: #d1d5db;
}
.stroke-gray-400 {
  stroke: #9ca3af;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.\\!p-1 {
  padding: 0.25rem !important;
}
.\\!p-3 {
  padding: 0.75rem !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.\\!px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-1\\.5 {
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
}
.\\!px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!px-3\\.5 {
  padding-left: 0.875rem !important;
  padding-right: 0.875rem !important;
}
.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\\!py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.\\!py-1\\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.\\!py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.\\!py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.\\!py-8 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-14 {
  padding-bottom: 3.5rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pb-28 {
  padding-bottom: 7rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-7 {
  padding-bottom: 1.75rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[env\\(safe-area-inset-bottom\\)\\] {
  padding-bottom: env(safe-area-inset-bottom);
}
.pb-\\[max\\(0\\.25rem\\2c env\\(safe-area-inset-bottom\\)\\)\\] {
  padding-bottom: max(0.25rem,env(safe-area-inset-bottom));
}
.pb-\\[max\\(0\\.75rem\\2c env\\(safe-area-inset-bottom\\)\\)\\] {
  padding-bottom: max(0.75rem,env(safe-area-inset-bottom));
}
.pb-\\[max\\(1rem\\2c env\\(safe-area-inset-bottom\\)\\)\\] {
  padding-bottom: max(1rem,env(safe-area-inset-bottom));
}
.pe-1 {
  padding-inline-end: 0.25rem;
}
.pe-10 {
  padding-inline-end: 2.5rem;
}
.pe-11 {
  padding-inline-end: 2.75rem;
}
.pe-14 {
  padding-inline-end: 3.5rem;
}
.pe-16 {
  padding-inline-end: 4rem;
}
.pe-2 {
  padding-inline-end: 0.5rem;
}
.pe-3 {
  padding-inline-end: 0.75rem;
}
.pe-3\\.5 {
  padding-inline-end: 0.875rem;
}
.pe-5 {
  padding-inline-end: 1.25rem;
}
.pe-6 {
  padding-inline-end: 1.5rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-24 {
  padding-left: 6rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-1\\.5 {
  padding-right: 0.375rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-24 {
  padding-right: 6rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.ps-1 {
  padding-inline-start: 0.25rem;
}
.ps-1\\.5 {
  padding-inline-start: 0.375rem;
}
.ps-10 {
  padding-inline-start: 2.5rem;
}
.ps-11 {
  padding-inline-start: 2.75rem;
}
.ps-2 {
  padding-inline-start: 0.5rem;
}
.ps-3 {
  padding-inline-start: 0.75rem;
}
.ps-4 {
  padding-inline-start: 1rem;
}
.ps-9 {
  padding-inline-start: 2.25rem;
}
.ps-\\[18px\\] {
  padding-inline-start: 18px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-24 {
  padding-top: 6rem;
}
.pt-28 {
  padding-top: 7rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-32 {
  padding-top: 8rem;
}
.pt-36 {
  padding-top: 9rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-40 {
  padding-top: 10rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[1\\.35rem\\] {
  padding-top: 1.35rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.font-cairo {
  font-family: Cairo, sans-serif;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: Poppins, sans-serif;
}
.\\!text-\\[13px\\] {
  font-size: 13px !important;
}
.\\!text-sm {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.\\!text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[13\\.5px\\] {
  font-size: 13.5px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-normal {
  font-weight: 400 !important;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.\\!normal-case {
  text-transform: none !important;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-\\[1\\.06\\] {
  line-height: 1.06;
}
.leading-\\[1\\.15\\] {
  line-height: 1.15;
}
.leading-\\[1\\.18\\] {
  line-height: 1.18;
}
.leading-\\[1\\.25\\] {
  line-height: 1.25;
}
.leading-\\[1\\.2\\] {
  line-height: 1.2;
}
.leading-\\[1\\.4\\] {
  line-height: 1.4;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-0\\.01em\\] {
  letter-spacing: -0.01em;
}
.tracking-\\[-0\\.02em\\] {
  letter-spacing: -0.02em;
}
.tracking-\\[-0\\.04em\\] {
  letter-spacing: -0.04em;
}
.tracking-\\[0\\.01em\\] {
  letter-spacing: 0.01em;
}
.tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.3em\\] {
  letter-spacing: 0.3em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.\\!text-\\[color\\:var\\(--acc\\)\\] {
  color: var(--acc) !important;
}
.\\!text-\\[color\\:var\\(--nc-card\\)\\] {
  color: var(--nc-card) !important;
}
.\\!text-\\[color\\:var\\(--nc-ink\\)\\] {
  color: var(--nc-ink) !important;
}
.\\!text-\\[var\\(--pg-card\\)\\] {
  color: var(--pg-card) !important;
}
.\\!text-amber-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(217 119 6 / var(--tw-text-opacity)) !important;
}
.\\!text-amber-950 {
  --tw-text-opacity: 1 !important;
  color: rgb(69 26 3 / var(--tw-text-opacity)) !important;
}
.\\!text-emerald-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(52 211 153 / var(--tw-text-opacity)) !important;
}
.\\!text-emerald-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(4 120 87 / var(--tw-text-opacity)) !important;
}
.\\!text-gray-200 {
  --tw-text-opacity: 1 !important;
  color: rgb(229 231 235 / var(--tw-text-opacity)) !important;
}
.\\!text-gray-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(55 65 81 / var(--tw-text-opacity)) !important;
}
.\\!text-red-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity)) !important;
}
.\\!text-red-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(220 38 38 / var(--tw-text-opacity)) !important;
}
.\\!text-rose-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(244 63 94 / var(--tw-text-opacity)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#04261a\\] {
  --tw-text-opacity: 1;
  color: rgb(4 38 26 / var(--tw-text-opacity));
}
.text-\\[\\#39ff88\\] {
  --tw-text-opacity: 1;
  color: rgb(57 255 136 / var(--tw-text-opacity));
}
.text-\\[\\#f6f7f8\\] {
  --tw-text-opacity: 1;
  color: rgb(246 247 248 / var(--tw-text-opacity));
}
.text-\\[color\\:var\\(--acc\\)\\] {
  color: var(--acc);
}
.text-\\[color\\:var\\(--acc-ink\\)\\] {
  color: var(--acc-ink);
}
.text-\\[color\\:var\\(--deal\\)\\] {
  color: var(--deal);
}
.text-\\[color\\:var\\(--err\\)\\] {
  color: var(--err);
}
.text-\\[color\\:var\\(--icon\\)\\] {
  color: var(--icon);
}
.text-\\[color\\:var\\(--mu\\)\\] {
  color: var(--mu);
}
.text-\\[color\\:var\\(--mut\\)\\] {
  color: var(--mut);
}
.text-\\[color\\:var\\(--nb-ink\\)\\] {
  color: var(--nb-ink);
}
.text-\\[color\\:var\\(--nb-on\\)\\] {
  color: var(--nb-on);
}
.text-\\[color\\:var\\(--pos\\)\\] {
  color: var(--pos);
}
.text-\\[color\\:var\\(--sale\\)\\] {
  color: var(--sale);
}
.text-\\[color\\:var\\(--tx\\)\\] {
  color: var(--tx);
}
.text-\\[color\\:var\\(--txt\\)\\] {
  color: var(--txt);
}
.text-\\[var\\(--ink\\)\\] {
  color: var(--ink);
}
.text-\\[var\\(--pg-accent\\)\\] {
  color: var(--pg-accent);
}
.text-\\[var\\(--pg-ink\\)\\] {
  color: var(--pg-ink);
}
.text-\\[var\\(--pg-on\\)\\] {
  color: var(--pg-on);
}
.text-\\[var\\(--pm-ink\\)\\] {
  color: var(--pm-ink);
}
.text-\\[var\\(--pm-on\\)\\] {
  color: var(--pm-on);
}
.text-\\[var\\(--soft\\)\\] {
  color: var(--soft);
}
.text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity));
}
.text-amber-950 {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-cyan-300 {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity));
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity));
}
.text-emerald-100 {
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity));
}
.text-emerald-100\\/80 {
  color: rgb(209 250 229 / 0.8);
}
.text-emerald-200\\/60 {
  color: rgb(167 243 208 / 0.6);
}
.text-emerald-200\\/70 {
  color: rgb(167 243 208 / 0.7);
}
.text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.text-emerald-50 {
  --tw-text-opacity: 1;
  color: rgb(236 253 245 / var(--tw-text-opacity));
}
.text-emerald-50\\/80 {
  color: rgb(236 253 245 / 0.8);
}
.text-emerald-50\\/85 {
  color: rgb(236 253 245 / 0.85);
}
.text-emerald-50\\/90 {
  color: rgb(236 253 245 / 0.9);
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity));
}
.text-emerald-800\\/70 {
  color: rgb(6 95 70 / 0.7);
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity));
}
.text-emerald-900\\/70 {
  color: rgb(6 78 59 / 0.7);
}
.text-emerald-900\\/80 {
  color: rgb(6 78 59 / 0.8);
}
.text-emerald-950 {
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-indigo-300 {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}
.text-lime-900\\/80 {
  color: rgb(54 83 20 / 0.8);
}
.text-lime-950 {
  --tw-text-opacity: 1;
  color: rgb(26 46 5 / var(--tw-text-opacity));
}
.text-neutral-200 {
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity));
}
.text-neutral-300 {
  --tw-text-opacity: 1;
  color: rgb(212 212 212 / var(--tw-text-opacity));
}
.text-neutral-400 {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity));
}
.text-orange-300 {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-rose-300 {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity));
}
.text-rose-400 {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity));
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity));
}
.text-rose-700 {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity));
}
.text-sky-300 {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity));
}
.text-sky-400 {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity));
}
.text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity));
}
.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}
.text-slate-400\\/80 {
  color: rgb(148 163 184 / 0.8);
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.text-teal-300 {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity));
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity));
}
.text-teal-900\\/80 {
  color: rgb(19 78 74 / 0.8);
}
.text-teal-950 {
  --tw-text-opacity: 1;
  color: rgb(4 47 46 / var(--tw-text-opacity));
}
.text-violet-300 {
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity));
}
.text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.no-underline {
  text-decoration-line: none;
}
.decoration-\\[color\\:var\\(--acc\\)\\] {
  text-decoration-color: var(--acc);
}
.decoration-white\\/60 {
  text-decoration-color: rgb(255 255 255 / 0.6);
}
.decoration-2 {
  text-decoration-thickness: 2px;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.accent-emerald-500 {
  accent-color: #10b981;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-15 {
  opacity: 0.15;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-35 {
  opacity: 0.35;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-85 {
  opacity: 0.85;
}
.opacity-90 {
  opacity: 0.9;
}
.opacity-95 {
  opacity: 0.95;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-8px_30px_rgba\\(0\\2c 0\\2c 0\\2c \\.14\\)\\] {
  --tw-shadow: 0 -8px 30px rgba(0,0,0,.14);
  --tw-shadow-colored: 0 -8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_2px_rgba\\(0\\2c 0\\2c 0\\2c \\.2\\)\\] {
  --tw-shadow: 0 0 0 2px rgba(0,0,0,.2);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_4px_rgba\\(16\\2c 185\\2c 129\\2c \\.18\\)\\] {
  --tw-shadow: 0 0 0 4px rgba(16,185,129,.18);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_6px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.7\\)\\] {
  --tw-shadow: 0 0 6px rgba(16,185,129,0.7);
  --tw-shadow-colored: 0 0 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.7\\)\\] {
  --tw-shadow: 0 0 8px rgba(16,185,129,0.7);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_34px_rgba\\(5\\2c 150\\2c 105\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 10px 34px rgba(5,150,105,0.14);
  --tw-shadow-colored: 0 10px 34px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 10px 40px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 10px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 1px 0 0 rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_40px_-10px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.4\\)\\] {
  --tw-shadow: 0 20px 40px -10px rgba(16,185,129,0.4);
  --tw-shadow-colored: 0 20px 40px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_0_0_\\#047857\\] {
  --tw-shadow: 0 2px 0 0 #047857;
  --tw-shadow-colored: 0 2px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_0_0_\\#9f1239\\] {
  --tw-shadow: 0 2px 0 0 #9f1239;
  --tw-shadow-colored: 0 2px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_0_0_\\#b45309\\] {
  --tw-shadow: 0 2px 0 0 #b45309;
  --tw-shadow-colored: 0 2px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_0_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 2px 0 0 rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 2px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_0_0_var\\(--nb-line\\)\\] {
  --tw-shadow: 0 2px 0 0 var(--nb-line);
  --tw-shadow-colored: 0 2px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_0_0_\\#022c22\\] {
  --tw-shadow: 0 3px 0 0 #022c22;
  --tw-shadow-colored: 0 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_0_0_\\#030712\\] {
  --tw-shadow: 0 3px 0 0 #030712;
  --tw-shadow-colored: 0 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_0_0_\\#047857\\] {
  --tw-shadow: 0 3px 0 0 #047857;
  --tw-shadow-colored: 0 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_0_0_\\#075985\\] {
  --tw-shadow: 0 3px 0 0 #075985;
  --tw-shadow-colored: 0 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_0_0_\\#5b21b6\\] {
  --tw-shadow: 0 3px 0 0 #5b21b6;
  --tw-shadow-colored: 0 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_0_0_\\#92400e\\] {
  --tw-shadow: 0 3px 0 0 #92400e;
  --tw-shadow-colored: 0 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_0_0_\\#a7f3d0\\] {
  --tw-shadow: 0 3px 0 0 #a7f3d0;
  --tw-shadow-colored: 0 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_0_0_\\#d1d5db\\] {
  --tw-shadow: 0 3px 0 0 #d1d5db;
  --tw-shadow-colored: 0 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_0_0_\\#030712\\] {
  --tw-shadow: 0 4px 0 0 #030712;
  --tw-shadow-colored: 0 4px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_0_0_\\#047857\\2c 0_10px_16px_-8px_rgba\\(5\\2c 150\\2c 105\\2c 0\\.6\\)\\] {
  --tw-shadow: 0 4px 0 0 #047857,0 10px 16px -8px rgba(5,150,105,0.6);
  --tw-shadow-colored: 0 4px 0 0 var(--tw-shadow-color), 0 10px 16px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_0_0_\\#047857\\] {
  --tw-shadow: 0 4px 0 0 #047857;
  --tw-shadow-colored: 0 4px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_0_0_\\#075985\\2c 0_10px_14px_-8px_rgba\\(7\\2c 89\\2c 133\\2c 0\\.7\\)\\] {
  --tw-shadow: 0 4px 0 0 #075985,0 10px 14px -8px rgba(7,89,133,0.7);
  --tw-shadow-colored: 0 4px 0 0 var(--tw-shadow-color), 0 10px 14px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_0_0_\\#1e3a8a\\2c 0_10px_14px_-8px_rgba\\(30\\2c 58\\2c 138\\2c 0\\.7\\)\\] {
  --tw-shadow: 0 4px 0 0 #1e3a8a,0 10px 14px -8px rgba(30,58,138,0.7);
  --tw-shadow-colored: 0 4px 0 0 var(--tw-shadow-color), 0 10px 14px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_0_0_\\#9f1239\\2c 0_10px_14px_-8px_rgba\\(159\\2c 18\\2c 57\\2c 0\\.7\\)\\] {
  --tw-shadow: 0 4px 0 0 #9f1239,0 10px 14px -8px rgba(159,18,57,0.7);
  --tw-shadow-colored: 0 4px 0 0 var(--tw-shadow-color), 0 10px 14px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_0_0_\\#9f1239\\2c 0_10px_16px_-8px_rgba\\(225\\2c 29\\2c 72\\2c 0\\.6\\)\\] {
  --tw-shadow: 0 4px 0 0 #9f1239,0 10px 16px -8px rgba(225,29,72,0.6);
  --tw-shadow-colored: 0 4px 0 0 var(--tw-shadow-color), 0 10px 16px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_0_0_\\#9f1239\\] {
  --tw-shadow: 0 4px 0 0 #9f1239;
  --tw-shadow-colored: 0 4px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_0_0_\\#d1d5db\\] {
  --tw-shadow: 0 4px 0 0 #d1d5db;
  --tw-shadow-colored: 0 4px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_12px_-4px_var\\(--acc\\)\\] {
  --tw-shadow: 0 4px 12px -4px var(--acc);
  --tw-shadow-colored: 0 4px 12px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_5px_0_0_\\#022c22\\2c 0_14px_22px_-8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 5px 0 0 #022c22,0 14px 22px -8px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 5px 0 0 var(--tw-shadow-color), 0 14px 22px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_5px_0_0_\\#022c22\\] {
  --tw-shadow: 0 5px 0 0 #022c22;
  --tw-shadow-colored: 0 5px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_5px_0_0_\\#065f46\\2c 0_14px_22px_-8px_rgba\\(2\\2c 44\\2c 34\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 5px 0 0 #065f46,0 14px 22px -8px rgba(2,44,34,0.5);
  --tw-shadow-colored: 0 5px 0 0 var(--tw-shadow-color), 0 14px 22px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_5px_0_0_\\#065f46\\] {
  --tw-shadow: 0 5px 0 0 #065f46;
  --tw-shadow-colored: 0 5px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_12px_-4px\\] {
  --tw-shadow: 0 6px 12px -4px;
  --tw-shadow-colored: 0 6px 12px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_16px_-8px_var\\(--acc\\)\\] {
  --tw-shadow: 0 6px 16px -8px var(--acc);
  --tw-shadow-colored: 0 6px 16px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_14px_-6px\\] {
  --tw-shadow: 0 8px 14px -6px;
  --tw-shadow-colored: 0 8px 14px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_70px_rgba\\(6\\2c 78\\2c 59\\2c \\.22\\)\\] {
  --tw-shadow: inset 0 0 70px rgba(6,78,59,.22);
  --tw-shadow-colored: inset 0 0 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_80px_rgba\\(0\\2c 0\\2c 0\\2c \\.55\\)\\] {
  --tw-shadow: inset 0 0 80px rgba(0,0,0,.55);
  --tw-shadow-colored: inset 0 0 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c \\.25\\)\\2c 0_8px_16px_-8px_rgba\\(5\\2c 150\\2c 105\\2c \\.8\\)\\] {
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,.25),0 8px 16px -8px rgba(5,150,105,.8);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 8px 16px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-amber-600\\/40 {
  --tw-shadow-color: rgb(217 119 6 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/10 {
  --tw-shadow-color: rgb(0 0 0 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/15 {
  --tw-shadow-color: rgb(0 0 0 / 0.15);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/20 {
  --tw-shadow-color: rgb(0 0 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/25 {
  --tw-shadow-color: rgb(0 0 0 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/30 {
  --tw-shadow-color: rgb(0 0 0 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/40 {
  --tw-shadow-color: rgb(0 0 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/5 {
  --tw-shadow-color: rgb(0 0 0 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/50 {
  --tw-shadow-color: rgb(0 0 0 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-400\\/10 {
  --tw-shadow-color: rgb(52 211 153 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-400\\/20 {
  --tw-shadow-color: rgb(52 211 153 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/10 {
  --tw-shadow-color: rgb(16 185 129 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/20 {
  --tw-shadow-color: rgb(16 185 129 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/25 {
  --tw-shadow-color: rgb(16 185 129 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-600\\/40 {
  --tw-shadow-color: rgb(5 150 105 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-900\\/20 {
  --tw-shadow-color: rgb(6 78 59 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-900\\/25 {
  --tw-shadow-color: rgb(6 78 59 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-900\\/30 {
  --tw-shadow-color: rgb(6 78 59 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-950\\/5 {
  --tw-shadow-color: rgb(2 44 34 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-200\\/20 {
  --tw-shadow-color: rgb(229 231 235 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-200\\/70 {
  --tw-shadow-color: rgb(229 231 235 / 0.7);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-300\\/50 {
  --tw-shadow-color: rgb(209 213 219 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-300\\/60 {
  --tw-shadow-color: rgb(209 213 219 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/20 {
  --tw-shadow-color: rgb(249 115 22 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-500\\/25 {
  --tw-shadow-color: rgb(244 63 94 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-600\\/40 {
  --tw-shadow-color: rgb(225 29 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-sky-600\\/40 {
  --tw-shadow-color: rgb(2 132 199 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-600\\/40 {
  --tw-shadow-color: rgb(13 148 136 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-violet-600\\/40 {
  --tw-shadow-color: rgb(124 58 237 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-\\[color\\:var\\(--bd\\)\\] {
  --tw-ring-color: var(--bd);
}
.ring-emerald-500\\/15 {
  --tw-ring-color: rgb(16 185 129 / 0.15);
}
.ring-emerald-500\\/20 {
  --tw-ring-color: rgb(16 185 129 / 0.2);
}
.ring-emerald-500\\/25 {
  --tw-ring-color: rgb(16 185 129 / 0.25);
}
.ring-emerald-500\\/30 {
  --tw-ring-color: rgb(16 185 129 / 0.3);
}
.ring-emerald-500\\/50 {
  --tw-ring-color: rgb(16 185 129 / 0.5);
}
.ring-emerald-500\\/60 {
  --tw-ring-color: rgb(16 185 129 / 0.6);
}
.ring-emerald-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 150 105 / var(--tw-ring-opacity));
}
.ring-gray-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(55 65 81 / var(--tw-ring-opacity));
}
.ring-transparent {
  --tw-ring-color: transparent;
}
.ring-white\\/20 {
  --tw-ring-color: rgb(255 255 255 / 0.2);
}
.ring-white\\/30 {
  --tw-ring-color: rgb(255 255 255 / 0.3);
}
.ring-white\\/40 {
  --tw-ring-color: rgb(255 255 255 / 0.4);
}
.ring-white\\/60 {
  --tw-ring-color: rgb(255 255 255 / 0.6);
}
.ring-white\\/70 {
  --tw-ring-color: rgb(255 255 255 / 0.7);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl {
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[2px\\] {
  --tw-blur: blur(2px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[3px\\] {
  --tw-blur: blur(3px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-md {
  --tw-blur: blur(12px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-2xl {
  --tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\] {
  --tw-drop-shadow: drop-shadow(0 2px 0 rgba(0,0,0,0.2));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-drop-shadow: drop-shadow(0 2px 0 rgba(0,0,0,0.3));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_2px_1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\] {
  --tw-drop-shadow: drop-shadow(0 2px 1px rgba(0,0,0,0.35));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_4px_4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-drop-shadow: drop-shadow(0 4px 4px rgba(0,0,0,0.3));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_6px_10px_rgba\\(0\\2c 0\\2c 0\\2c \\.25\\)\\] {
  --tw-drop-shadow: drop-shadow(0 6px 10px rgba(0,0,0,.25));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_6px_5px_rgba\\(2\\2c 44\\2c 34\\2c 0\\.35\\)\\] {
  --tw-drop-shadow: drop-shadow(0 6px 5px rgba(2,44,34,0.35));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_6px_6px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.18\\)\\] {
  --tw-drop-shadow: drop-shadow(0 6px 6px rgba(0,0,0,0.18));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\] {
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c border-color\\2c color\\2c transform\\] {
  transition-property: background-color,border-color,color,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c border-color\\2c transform\\2c color\\] {
  transition-property: background-color,border-color,transform,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c border-color\\2c transform\\] {
  transition-property: background-color,border-color,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c box-shadow\\2c margin\\2c padding\\2c border-radius\\2c transform\\] {
  transition-property: background-color,box-shadow,margin,padding,border-radius,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c box-shadow\\2c transform\\] {
  transition-property: background-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c transform\\] {
  transition-property: background-color,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border-color\\2c box-shadow\\2c background-color\\] {
  transition-property: border-color,box-shadow,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border-color\\2c box-shadow\\] {
  transition-property: border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[box-shadow\\2c border-color\\2c opacity\\] {
  transition-property: box-shadow,border-color,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[box-shadow\\2c border-color\\] {
  transition-property: box-shadow,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[box-shadow\\] {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[grid-template-rows\\2c opacity\\] {
  transition-property: grid-template-rows,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[height\\] {
  transition-property: height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c transform\\2c visibility\\] {
  transition-property: opacity,transform,visibility;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c transform\\] {
  transition-property: opacity,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[top\\2c font-size\\2c color\\] {
  transition-property: top,font-size,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c background-color\\2c border-color\\2c box-shadow\\2c opacity\\] {
  transition-property: transform,background-color,border-color,box-shadow,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c background-color\\2c border-color\\2c box-shadow\\] {
  transition-property: transform,background-color,border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c background-color\\2c border-color\\2c opacity\\] {
  transition-property: transform,background-color,border-color,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c background-color\\2c border-color\\] {
  transition-property: transform,background-color,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c background-color\\2c box-shadow\\] {
  transition-property: transform,background-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c background-color\\] {
  transition-property: transform,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c border-color\\2c background-color\\2c box-shadow\\] {
  transition-property: transform,border-color,background-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c border-color\\2c box-shadow\\] {
  transition-property: transform,border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c border-color\\] {
  transition-property: transform,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c box-shadow\\2c background-color\\2c border-color\\2c color\\2c filter\\] {
  transition-property: transform,box-shadow,background-color,border-color,color,filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c box-shadow\\2c background-color\\2c color\\] {
  transition-property: transform,box-shadow,background-color,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c box-shadow\\2c border-color\\] {
  transition-property: transform,box-shadow,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c box-shadow\\2c opacity\\] {
  transition-property: transform,box-shadow,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c box-shadow\\] {
  transition-property: transform,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c filter\\2c background-color\\2c box-shadow\\] {
  transition-property: transform,filter,background-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c visibility\\] {
  transition-property: transform,visibility;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c width\\] {
  transition-property: transform,width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\2c background-color\\] {
  transition-property: width,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-\\[cubic-bezier\\(\\.22\\2c 1\\2c \\.36\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(.22,1,.36,1);
}
.ease-\\[cubic-bezier\\(\\.34\\2c 1\\.56\\2c \\.64\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(.34,1.56,.64,1);
}
.ease-\\[cubic-bezier\\(0\\.16\\2c 1\\2c 0\\.3\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(0.16,1,0.3,1);
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  transition-timing-function: linear;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-transform {
  will-change: transform;
}
.\\[--acc-hi\\:\\#047857\\] {
  --acc-hi: #047857;
}
.\\[--acc-hi\\:\\#34d399\\] {
  --acc-hi: #34d399;
}
.\\[--acc-ink\\:\\#022c22\\] {
  --acc-ink: #022c22;
}
.\\[--acc\\:\\#059669\\] {
  --acc: #059669;
}
.\\[--acc\\:\\#10b981\\] {
  --acc: #10b981;
}
.\\[--acc\\:\\#34d399\\] {
  --acc: #34d399;
}
.\\[--acc\\:\\#39ff88\\] {
  --acc: #39ff88;
}
.\\[--card\\:\\#1e1e1e\\] {
  --card: #1e1e1e;
}
.\\[--card\\:\\#2a2a2a\\] {
  --card: #2a2a2a;
}
.\\[--card\\:\\#ffffff\\] {
  --card: #ffffff;
}
.\\[--deal\\:\\#c2410c\\] {
  --deal: #c2410c;
}
.\\[--deal\\:\\#fb923c\\] {
  --deal: #fb923c;
}
.\\[--dx\\:1\\] {
  --dx: 1;
}
.\\[--err\\:\\#e11d48\\] {
  --err: #e11d48;
}
.\\[--err\\:\\#fb7185\\] {
  --err: #fb7185;
}
.\\[--field\\:\\#1e1e1e\\] {
  --field: #1e1e1e;
}
.\\[--field\\:\\#ffffff\\] {
  --field: #ffffff;
}
.\\[--fld\\:\\#1e1e1e\\] {
  --fld: #1e1e1e;
}
.\\[--fld\\:\\#ffffff\\] {
  --fld: #ffffff;
}
.\\[--hist\\:\\#3a3a3a\\] {
  --hist: #3a3a3a;
}
.\\[--hist\\:\\#d1d5db\\] {
  --hist: #d1d5db;
}
.\\[--icon\\:\\#059669\\] {
  --icon: #059669;
}
.\\[--icon\\:\\#39ff88\\] {
  --icon: #39ff88;
}
.\\[--ink\\:\\#000000\\] {
  --ink: #000000;
}
.\\[--ink\\:\\#000\\] {
  --ink: #000;
}
.\\[--ink\\:\\#022c22\\] {
  --ink: #022c22;
}
.\\[--line\\:\\#e5e7eb\\] {
  --line: #e5e7eb;
}
.\\[--line\\:rgba\\(255\\2c 255\\2c 255\\2c \\.12\\)\\] {
  --line: rgba(255,255,255,.12);
}
.\\[--mut\\:\\#4b5563\\] {
  --mut: #4b5563;
}
.\\[--mut\\:\\#6b7280\\] {
  --mut: #6b7280;
}
.\\[--mut\\:\\#a3a3a3\\] {
  --mut: #a3a3a3;
}
.\\[--page\\:\\#141414\\] {
  --page: #141414;
}
.\\[--page\\:\\#f9fafb\\] {
  --page: #f9fafb;
}
.\\[--sale\\:\\#c2410c\\] {
  --sale: #c2410c;
}
.\\[--sale\\:\\#fb923c\\] {
  --sale: #fb923c;
}
.\\[--sh\\:\\#000000\\] {
  --sh: #000000;
}
.\\[--sh\\:\\#000\\] {
  --sh: #000;
}
.\\[--sh\\:\\#022c22\\] {
  --sh: #022c22;
}
.\\[--soft\\:\\#1e1e1e\\] {
  --soft: #1e1e1e;
}
.\\[--soft\\:\\#2a2a2a\\] {
  --soft: #2a2a2a;
}
.\\[--soft\\:\\#f3f4f6\\] {
  --soft: #f3f4f6;
}
.\\[--tint\\:\\#0f2a20\\] {
  --tint: #0f2a20;
}
.\\[--tint\\:\\#ecfdf5\\] {
  --tint: #ecfdf5;
}
.\\[--txt\\:\\#022c22\\] {
  --txt: #022c22;
}
.\\[--txt\\:\\#111827\\] {
  --txt: #111827;
}
.\\[--txt\\:\\#ffffff\\] {
  --txt: #ffffff;
}
.\\[border-inline-start\\:4px_solid_var\\(--acc\\)\\] {
  border-inline-start: 4px solid var(--acc);
}
.\\[box-shadow\\:2px_2px_0_0_\\#000\\] {
  box-shadow: 2px 2px 0 0 #000;
}
.\\[box-shadow\\:6px_6px_0_0_\\#000\\] {
  box-shadow: 6px 6px 0 0 #000;
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*2px\\)_2px_0_0_\\#000\\] {
  box-shadow: calc(var(--dx) * 2px) 2px 0 0 #000;
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*2px\\)_2px_0_0_\\#022c22\\] {
  box-shadow: calc(var(--dx) * 2px) 2px 0 0 #022c22;
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*3px\\)_3px_0_0_\\#000\\] {
  box-shadow: calc(var(--dx) * 3px) 3px 0 0 #000;
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*3px\\)_3px_0_0_\\#022c22\\] {
  box-shadow: calc(var(--dx) * 3px) 3px 0 0 #022c22;
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*3px\\)_3px_0_0_var\\(--err\\)\\] {
  box-shadow: calc(var(--dx) * 3px) 3px 0 0 var(--err);
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*3px\\)_3px_0_0_var\\(--sh\\)\\] {
  box-shadow: calc(var(--dx) * 3px) 3px 0 0 var(--sh);
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*4px\\)_4px_0_0_\\#000\\] {
  box-shadow: calc(var(--dx) * 4px) 4px 0 0 #000;
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*4px\\)_4px_0_0_\\#022c22\\] {
  box-shadow: calc(var(--dx) * 4px) 4px 0 0 #022c22;
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*4px\\)_4px_0_0_var\\(--sh\\)\\] {
  box-shadow: calc(var(--dx) * 4px) 4px 0 0 var(--sh);
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*4px\\)_4px_0_0_var\\(--svc-sh\\)\\] {
  box-shadow: calc(var(--dx) * 4px) 4px 0 0 var(--svc-sh);
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*6px\\)_6px_0_0_var\\(--sh\\)\\] {
  box-shadow: calc(var(--dx) * 6px) 6px 0 0 var(--sh);
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*8px\\)_8px_0_0_\\#000\\] {
  box-shadow: calc(var(--dx) * 8px) 8px 0 0 #000;
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*8px\\)_8px_0_0_\\#022c22\\] {
  box-shadow: calc(var(--dx) * 8px) 8px 0 0 #022c22;
}
.\\[box-shadow\\:calc\\(var\\(--dx\\)\\*8px\\)_8px_0_0_var\\(--sh\\)\\] {
  box-shadow: calc(var(--dx) * 8px) 8px 0 0 var(--sh);
}
.\\[box-shadow\\:calc\\(var\\(--nc-dx\\)\\*3px\\)_3px_0_0_var\\(--nc-shadow\\)\\] {
  box-shadow: calc(var(--nc-dx) * 3px) 3px 0 0 var(--nc-shadow);
}
.\\[clip-path\\:inset\\(0_0_50\\%_0\\)\\] {
  clip-path: inset(0 0 50% 0);
}
.\\[clip-path\\:inset\\(50\\%_0_0_0\\)\\] {
  clip-path: inset(50% 0 0 0);
}
.\\[color-scheme\\:dark\\] {
  color-scheme: dark;
}
.\\[contain-intrinsic-size\\:auto_480px\\] {
  contain-intrinsic-size: auto 480px;
}
.\\[contain-intrinsic-size\\:auto_520px\\] {
  contain-intrinsic-size: auto 520px;
}
.\\[contain-intrinsic-size\\:auto_640px\\] {
  contain-intrinsic-size: auto 640px;
}
.\\[contain-intrinsic-size\\:auto_72px\\] {
  contain-intrinsic-size: auto 72px;
}
.\\[contain-intrinsic-size\\:auto_760px\\] {
  contain-intrinsic-size: auto 760px;
}
.\\[contain-intrinsic-size\\:auto_80px\\] {
  contain-intrinsic-size: auto 80px;
}
.\\[contain-intrinsic-size\\:auto_84px\\] {
  contain-intrinsic-size: auto 84px;
}
.\\[contain-intrinsic-size\\:auto_900px\\] {
  contain-intrinsic-size: auto 900px;
}
.\\[contain\\:layout_paint\\] {
  contain: layout paint;
}
.\\[contain\\:paint\\] {
  contain: paint;
}
.\\[content-visibility\\:auto\\] {
  content-visibility: auto;
}
.\\[overflow-x\\:clip\\] {
  overflow-x: clip;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}
.\\[text-wrap\\:balance\\] {
  text-wrap: balance;
}
::-webkit-scrollbar{
  width: 6px;;
}
::-webkit-scrollbar-track{
  background-color: #f1f1f1;
}
::-webkit-scrollbar-thumb{
  background-color: #888;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover{
  background-color: #555;

}



.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
}
.animate-float { animation: float 6s ease-in-out infinite; }
.animation-delay-500 { animation-delay: 0.5s; }
.animation-delay-1000 { animation-delay: 1s; }
.animation-delay-1500 { animation-delay: 1.5s; }
/* Custom Scrollbar */
.custom-scroll::-webkit-scrollbar {
  height: 8px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #3b82f6; /* Tailwind blue-500 */
  border-radius: 10px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #2563eb; /* Tailwind blue-600 */
}

/* Firefox */
.custom-scroll {
  scrollbar-color: #3b82f6 transparent;
  scrollbar-width: thin;
}
@keyframes float-slow {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
}
@keyframes float-medium {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-15px) rotate(-3deg); }
}
@keyframes float-fast {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}
@keyframes spin-slow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes float-3d {
  0%, 100% { transform: translateY(0) rotateY(12deg) rotateX(6deg); }
  50% { transform: translateY(-25px) rotateY(-12deg) rotateX(-6deg); }
}
@keyframes float-3d-delay {
  0%, 100% { transform: translateY(0) rotateY(-15deg) rotateX(8deg); }
  50% { transform: translateY(-20px) rotateY(15deg) rotateX(-8deg); }
}
@keyframes float-3d-fast {
  0%, 100% { transform: translateY(0) rotateY(20deg) rotateX(10deg); }
  50% { transform: translateY(-15px) rotateY(-20deg) rotateX(-10deg); }
}
@keyframes slideIn {
  from { opacity: 0; transform: translateY(30px) scale(0.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.animate-float-slow { animation: float-slow 6s ease-in-out infinite; }
.animate-float-medium { animation: float-medium 5s ease-in-out infinite; }
.animate-float-fast { animation: float-fast 4s ease-in-out infinite; }
.animate-spin-slow { animation: spin-slow 20s linear infinite; }
.animate-float-3d { animation: float-3d 8s ease-in-out infinite; }
.animate-float-3d-delay { animation: float-3d-delay 7s ease-in-out infinite 1s; }
.animate-float-3d-fast { animation: float-3d-fast 5s ease-in-out infinite; }
.animate-slideIn { animation: slideIn 0.5s ease-out forwards; opacity: 0; }
.animate-fadeIn { animation: fadeIn 0.5s ease-out; }

.perspective-1000 { perspective: 1000px; }
.rotate-y-12 { transform: rotateY(12deg); }
.rotate-y--15 { transform: rotateY(-15deg); }
.rotate-y-20 { transform: rotateY(20deg); }
.rotate-x-6 { transform: rotateX(6deg); }
.rotate-x-8 { transform: rotateX(8deg); }
.rotate-x-10 { transform: rotateX(10deg); }

.hide-scrollbar::-webkit-scrollbar { display: none; }
.hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
.placeholder\\:font-medium::placeholder {
  font-weight: 500;
}
.placeholder\\:font-normal::placeholder {
  font-weight: 400;
}
.placeholder\\:text-\\[color\\:var\\(--mut\\)\\]::placeholder {
  color: var(--mut);
}
.placeholder\\:text-\\[var\\(--soft\\)\\]::placeholder {
  color: var(--soft);
}
.placeholder\\:text-gray-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.placeholder\\:text-gray-500::placeholder {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.placeholder\\:opacity-60::placeholder {
  opacity: 0.6;
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-0::after {
  content: var(--tw-content);
  inset: 0px;
}
.after\\:z-\\[1\\]::after {
  content: var(--tw-content);
  z-index: 1;
}
.first\\:pt-0:first-child {
  padding-top: 0px;
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.last\\:pb-0:last-child {
  padding-bottom: 0px;
}
.focus-within\\:border-emerald-500:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.focus-within\\:bg-gray-800:focus-within {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.focus-within\\:bg-white:focus-within {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.focus-within\\:opacity-100:focus-within {
  opacity: 1;
}
.focus-within\\:shadow-\\[0_0_0_4px_rgba\\(16\\2c 185\\2c 129\\2c \\.18\\)\\]:focus-within {
  --tw-shadow: 0 0 0 4px rgba(16,185,129,.18);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus-within\\:shadow-lg:focus-within {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus-within\\:shadow-emerald-900\\/10:focus-within {
  --tw-shadow-color: rgb(6 78 59 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.focus-within\\:outline:focus-within {
  outline-style: solid;
}
.focus-within\\:outline-\\[3px\\]:focus-within {
  outline-width: 3px;
}
.focus-within\\:outline-offset-2:focus-within {
  outline-offset: 2px;
}
.focus-within\\:outline-\\[color\\:var\\(--acc\\)\\]:focus-within {
  outline-color: var(--acc);
}
.focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-emerald-500\\/30:focus-within {
  --tw-ring-color: rgb(16 185 129 / 0.3);
}
.focus-within\\:ring-emerald-500\\/70:focus-within {
  --tw-ring-color: rgb(16 185 129 / 0.7);
}
.hover\\:-translate-x-1:hover {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-px:hover {
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.03\\]:hover {
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#39ff88\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(57 255 136 / var(--tw-border-opacity));
}
.hover\\:border-emerald-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity));
}
.hover\\:border-emerald-400\\/60:hover {
  border-color: rgb(52 211 153 / 0.6);
}
.hover\\:border-emerald-400\\/70:hover {
  border-color: rgb(52 211 153 / 0.7);
}
.hover\\:border-emerald-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.hover\\:border-emerald-500\\/60:hover {
  border-color: rgb(16 185 129 / 0.6);
}
.hover\\:border-emerald-500\\/70:hover {
  border-color: rgb(16 185 129 / 0.7);
}
.hover\\:border-emerald-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity));
}
.hover\\:border-gray-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.hover\\:border-gray-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.hover\\:border-gray-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.hover\\:border-orange-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity));
}
.hover\\:border-orange-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity));
}
.hover\\:bg-\\[\\#274a73\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(39 74 115 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#39ff88\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(57 255 136 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[color\\:var\\(--acc-hi\\)\\]:hover {
  background-color: var(--acc-hi);
}
.hover\\:bg-\\[color\\:var\\(--hov\\)\\]:hover {
  background-color: var(--hov);
}
.hover\\:bg-\\[color\\:var\\(--nb-gray\\)\\]:hover {
  background-color: var(--nb-gray);
}
.hover\\:bg-\\[color\\:var\\(--nc-gray\\)\\]:hover {
  background-color: var(--nc-gray);
}
.hover\\:bg-\\[color\\:var\\(--sf2\\)\\]:hover {
  background-color: var(--sf2);
}
.hover\\:bg-\\[color\\:var\\(--soft\\)\\]:hover {
  background-color: var(--soft);
}
.hover\\:bg-black\\/10:hover {
  background-color: rgb(0 0 0 / 0.1);
}
.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-50\\/60:hover {
  background-color: rgb(236 253 245 / 0.6);
}
.hover\\:bg-emerald-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-500\\/10:hover {
  background-color: rgb(16 185 129 / 0.1);
}
.hover\\:bg-emerald-500\\/5:hover {
  background-color: rgb(16 185 129 / 0.05);
}
.hover\\:bg-emerald-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-200\\/70:hover {
  background-color: rgb(229 231 235 / 0.7);
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-800\\/80:hover {
  background-color: rgb(31 41 55 / 0.8);
}
.hover\\:bg-orange-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity));
}
.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.hover\\:bg-red-500\\/25:hover {
  background-color: rgb(239 68 68 / 0.25);
}
.hover\\:bg-rose-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-500\\/20:hover {
  background-color: rgb(244 63 94 / 0.2);
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/15:hover {
  background-color: rgb(255 255 255 / 0.15);
}
.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/5:hover {
  background-color: rgb(255 255 255 / 0.05);
}
.hover\\:from-emerald-300:hover {
  --tw-gradient-from: #6ee7b7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(110 231 183 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-rose-300:hover {
  --tw-gradient-from: #fda4af var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 164 175 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:to-emerald-500:hover {
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.hover\\:to-rose-500:hover {
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.hover\\:\\!text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.hover\\:text-\\[\\#022c22\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity));
}
.hover\\:text-\\[\\#39ff88\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(57 255 136 / var(--tw-text-opacity));
}
.hover\\:text-\\[color\\:var\\(--acc\\)\\]:hover {
  color: var(--acc);
}
.hover\\:text-\\[color\\:var\\(--nb-accent\\)\\]:hover {
  color: var(--nb-accent);
}
.hover\\:text-\\[color\\:var\\(--nb-ink\\)\\]:hover {
  color: var(--nb-ink);
}
.hover\\:text-\\[color\\:var\\(--tx\\)\\]:hover {
  color: var(--tx);
}
.hover\\:text-\\[var\\(--nb-accent\\)\\]:hover {
  color: var(--nb-accent);
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.hover\\:text-emerald-300:hover {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity));
}
.hover\\:text-emerald-400:hover {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.hover\\:text-emerald-500:hover {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.hover\\:text-emerald-600:hover {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity));
}
.hover\\:text-emerald-700:hover {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity));
}
.hover\\:text-emerald-950:hover {
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity));
}
.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.hover\\:text-orange-500:hover {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}
.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.hover\\:text-rose-400:hover {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity));
}
.hover\\:text-rose-500:hover {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity));
}
.hover\\:text-rose-600:hover {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:no-underline:hover {
  text-decoration-line: none;
}
.hover\\:underline-offset-4:hover {
  text-underline-offset: 4px;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-black\\/30:hover {
  --tw-shadow-color: rgb(0 0 0 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-gray-200\\/70:hover {
  --tw-shadow-color: rgb(229 231 235 / 0.7);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:brightness-105:hover {
  --tw-brightness: brightness(1.05);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:brightness-110:hover {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:brightness-95:hover {
  --tw-brightness: brightness(.95);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:\\[box-shadow\\:calc\\(var\\(--dx\\)\\*4px\\)_4px_0_0_\\#000\\]:hover {
  box-shadow: calc(var(--dx) * 4px) 4px 0 0 #000;
}
.hover\\:\\[box-shadow\\:calc\\(var\\(--dx\\)\\*4px\\)_4px_0_0_\\#022c22\\]:hover {
  box-shadow: calc(var(--dx) * 4px) 4px 0 0 #022c22;
}
.focus\\:border-emerald-300:focus {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity));
}
.focus\\:border-emerald-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity));
}
.focus\\:border-emerald-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.focus\\:bg-gray-800:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.focus\\:opacity-100:focus {
  opacity: 1;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:\\!ring-rose-400\\/30:focus {
  --tw-ring-color: rgb(251 113 133 / 0.3) !important;
}
.focus\\:ring-emerald-400\\/10:focus {
  --tw-ring-color: rgb(52 211 153 / 0.1);
}
.focus\\:ring-emerald-400\\/40:focus {
  --tw-ring-color: rgb(52 211 153 / 0.4);
}
.focus\\:ring-emerald-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity));
}
.focus\\:ring-emerald-500\\/10:focus {
  --tw-ring-color: rgb(16 185 129 / 0.1);
}
.focus\\:ring-emerald-500\\/15:focus {
  --tw-ring-color: rgb(16 185 129 / 0.15);
}
.focus\\:ring-emerald-500\\/20:focus {
  --tw-ring-color: rgb(16 185 129 / 0.2);
}
.focus\\:ring-emerald-500\\/25:focus {
  --tw-ring-color: rgb(16 185 129 / 0.25);
}
.focus-visible\\:border-\\[\\#39ff88\\]:focus-visible {
  --tw-border-opacity: 1;
  border-color: rgb(57 255 136 / var(--tw-border-opacity));
}
.focus-visible\\:border-emerald-500:focus-visible {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.focus-visible\\:bg-\\[color\\:var\\(--soft\\)\\]:focus-visible {
  background-color: var(--soft);
}
.focus-visible\\:underline:focus-visible {
  text-decoration-line: underline;
}
.focus-visible\\:opacity-100:focus-visible {
  opacity: 1;
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:outline:focus-visible {
  outline-style: solid;
}
.focus-visible\\:outline-2:focus-visible {
  outline-width: 2px;
}
.focus-visible\\:outline-\\[3px\\]:focus-visible {
  outline-width: 3px;
}
.focus-visible\\:-outline-offset-2:focus-visible {
  outline-offset: -2px;
}
.focus-visible\\:outline-offset-2:focus-visible {
  outline-offset: 2px;
}
.focus-visible\\:outline-offset-4:focus-visible {
  outline-offset: 4px;
}
.focus-visible\\:outline-offset-\\[-2px\\]:focus-visible {
  outline-offset: -2px;
}
.focus-visible\\:outline-\\[\\#39ff88\\]:focus-visible {
  outline-color: #39ff88;
}
.focus-visible\\:outline-\\[color\\:var\\(--acc\\)\\]:focus-visible {
  outline-color: var(--acc);
}
.focus-visible\\:outline-\\[color\\:var\\(--g-accent\\)\\]:focus-visible {
  outline-color: var(--g-accent);
}
.focus-visible\\:outline-emerald-400:focus-visible {
  outline-color: #34d399;
}
.focus-visible\\:outline-emerald-500:focus-visible {
  outline-color: #10b981;
}
.focus-visible\\:outline-indigo-500:focus-visible {
  outline-color: #6366f1;
}
.focus-visible\\:outline-white:focus-visible {
  outline-color: #fff;
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-4:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-\\[color\\:var\\(--ring\\)\\]:focus-visible {
  --tw-ring-color: var(--ring);
}
.focus-visible\\:ring-emerald-400:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(52 211 153 / var(--tw-ring-opacity));
}
.focus-visible\\:ring-emerald-500\\/15:focus-visible {
  --tw-ring-color: rgb(16 185 129 / 0.15);
}
.focus-visible\\:ring-emerald-500\\/50:focus-visible {
  --tw-ring-color: rgb(16 185 129 / 0.5);
}
.focus-visible\\:ring-red-400\\/50:focus-visible {
  --tw-ring-color: rgb(248 113 113 / 0.5);
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-\\[color\\:var\\(--bg\\)\\]:focus-visible {
  --tw-ring-offset-color: var(--bg);
}
.focus-visible\\:after\\:outline:focus-visible::after {
  content: var(--tw-content);
  outline-style: solid;
}
.focus-visible\\:after\\:outline-\\[3px\\]:focus-visible::after {
  content: var(--tw-content);
  outline-width: 3px;
}
.focus-visible\\:after\\:-outline-offset-4:focus-visible::after {
  content: var(--tw-content);
  outline-offset: -4px;
}
.focus-visible\\:after\\:outline-\\[color\\:var\\(--acc\\)\\]:focus-visible::after {
  content: var(--tw-content);
  outline-color: var(--acc);
}
.active\\:translate-x-\\[calc\\(var\\(--dx\\)\\*2px\\)\\]:active {
  --tw-translate-x: calc(var(--dx) * 2px);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:translate-x-\\[calc\\(var\\(--dx\\)\\*3px\\)\\]:active {
  --tw-translate-x: calc(var(--dx) * 3px);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:translate-x-\\[calc\\(var\\(--dx\\)\\*4px\\)\\]:active {
  --tw-translate-x: calc(var(--dx) * 4px);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:translate-y-0:active {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:translate-y-0\\.5:active {
  --tw-translate-y: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:translate-y-1:active {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:translate-y-\\[2px\\]:active {
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:translate-y-\\[3px\\]:active {
  --tw-translate-y: 3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:translate-y-\\[4px\\]:active {
  --tw-translate-y: 4px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-90:active {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[\\.96\\]:active {
  --tw-scale-x: .96;
  --tw-scale-y: .96;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[\\.97\\]:active {
  --tw-scale-x: .97;
  --tw-scale-y: .97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[\\.98\\]:active {
  --tw-scale-x: .98;
  --tw-scale-y: .98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.97\\]:active {
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:shadow-\\[0_1px_0_0_\\#022c22\\]:active {
  --tw-shadow: 0 1px 0 0 #022c22;
  --tw-shadow-colored: 0 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:shadow-\\[0_1px_0_0_\\#030712\\]:active {
  --tw-shadow: 0 1px 0 0 #030712;
  --tw-shadow-colored: 0 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:shadow-\\[0_1px_0_0_\\#047857\\]:active {
  --tw-shadow: 0 1px 0 0 #047857;
  --tw-shadow-colored: 0 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:shadow-\\[0_1px_0_0_\\#065f46\\]:active {
  --tw-shadow: 0 1px 0 0 #065f46;
  --tw-shadow-colored: 0 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:shadow-\\[0_1px_0_0_\\#075985\\]:active {
  --tw-shadow: 0 1px 0 0 #075985;
  --tw-shadow-colored: 0 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:shadow-\\[0_1px_0_0_\\#1e3a8a\\]:active {
  --tw-shadow: 0 1px 0 0 #1e3a8a;
  --tw-shadow-colored: 0 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:shadow-\\[0_1px_0_0_\\#9f1239\\]:active {
  --tw-shadow: 0 1px 0 0 #9f1239;
  --tw-shadow-colored: 0 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:shadow-\\[0_1px_0_0_\\#d1d5db\\]:active {
  --tw-shadow: 0 1px 0 0 #d1d5db;
  --tw-shadow-colored: 0 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:\\[box-shadow\\:0_0_0_0_var\\(--sh\\)\\]:active {
  box-shadow: 0 0 0 0 var(--sh);
}
.active\\:\\[box-shadow\\:calc\\(var\\(--dx\\)\\*3px\\)_3px_0_0_var\\(--sh\\)\\]:active {
  box-shadow: calc(var(--dx) * 3px) 3px 0 0 var(--sh);
}
.active\\:\\[box-shadow\\:none\\]:active {
  box-shadow: none;
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:translate-y-0:disabled {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:cursor-wait:disabled {
  cursor: wait;
}
.disabled\\:no-underline:disabled {
  text-decoration-line: none;
}
.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-45:disabled {
  opacity: 0.45;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}
.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.disabled\\:\\[box-shadow\\:none\\]:disabled {
  box-shadow: none;
}
.disabled\\:active\\:translate-y-0:active:disabled {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group\\/search:focus-within .group-focus-within\\/search\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:focus-within .group-focus-within\\:text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:-translate-y-0\\.5 {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-rotate-3 {
  --tw-rotate: -3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-rotate-6 {
  --tw-rotate: -6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-\\[\\#39ff88\\] {
  --tw-border-opacity: 1;
  border-color: rgb(57 255 136 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-cyan-300 {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-orange-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-rose-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-rose-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-sky-300 {
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-sky-500 {
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-teal-300 {
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-violet-300 {
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:border-violet-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity));
}
.group:hover .group-hover\\:bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
.group:hover .group-hover\\:bg-emerald-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity));
}
.group:hover .group-hover\\:bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
.group:hover .group-hover\\:bg-orange-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity));
}
.group:hover .group-hover\\:text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:underline {
  text-decoration-line: underline;
}
.group:hover .group-hover\\:decoration-\\[\\#39ff88\\] {
  text-decoration-color: #39ff88;
}
.group:hover .group-hover\\:decoration-emerald-400 {
  text-decoration-color: #34d399;
}
.group:hover .group-hover\\:decoration-2 {
  text-decoration-thickness: 2px;
}
.group:hover .group-hover\\:underline-offset-4 {
  text-underline-offset: 4px;
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:opacity-60 {
  opacity: 0.6;
}
.group:focus-visible .group-focus-visible\\:opacity-100 {
  opacity: 1;
}
.group:focus-visible .group-focus-visible\\:opacity-60 {
  opacity: 0.6;
}
.group:active .group-active\\:scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-\\[1\\.05rem\\] {
  top: 1.05rem;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:font-semibold {
  font-weight: 600;
}
.peer:focus ~ .peer-focus\\:top-\\[0\\.55rem\\] {
  top: 0.55rem;
}
.peer:focus ~ .peer-focus\\:text-\\[11px\\] {
  font-size: 11px;
}
.peer:focus ~ .peer-focus\\:font-bold {
  font-weight: 700;
}
.peer:focus ~ .peer-focus\\:text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.aria-disabled\\:pointer-events-none[aria-disabled="true"] {
  pointer-events: none;
}
.aria-disabled\\:opacity-45[aria-disabled="true"] {
  opacity: 0.45;
}
@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:transform-none {
    transform: none;
  }

  .motion-reduce\\:animate-none {
    animation: none;
  }

  .motion-reduce\\:scroll-auto {
    scroll-behavior: auto;
  }

  .motion-reduce\\:transition-none {
    transition-property: none;
  }

  .motion-reduce\\:hover\\:transform-none:hover {
    transform: none;
  }
}
.dark\\:divide-gray-700\\/60:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(55 65 81 / 0.6);
}
.dark\\:divide-gray-800:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-divide-opacity));
}
.dark\\:border-emerald-500\\/10:is(.dark *) {
  border-color: rgb(16 185 129 / 0.1);
}
.dark\\:border-emerald-500\\/20:is(.dark *) {
  border-color: rgb(16 185 129 / 0.2);
}
.dark\\:border-emerald-500\\/25:is(.dark *) {
  border-color: rgb(16 185 129 / 0.25);
}
.dark\\:border-gray-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}
.dark\\:border-gray-700\\/50:is(.dark *) {
  border-color: rgb(55 65 81 / 0.5);
}
.dark\\:border-gray-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}
.dark\\:border-gray-900:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity));
}
.dark\\:border-indigo-900\\/30:is(.dark *) {
  border-color: rgb(49 46 129 / 0.3);
}
.dark\\:border-lime-900\\/50:is(.dark *) {
  border-color: rgb(54 83 20 / 0.5);
}
.dark\\:border-red-900:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity));
}
.dark\\:border-red-900\\/20:is(.dark *) {
  border-color: rgb(127 29 29 / 0.2);
}
.dark\\:\\!bg-gray-500:is(.dark *) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity)) !important;
}
.dark\\:bg-\\[\\#14233a\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(20 35 58 / var(--tw-bg-opacity));
}
.dark\\:bg-amber-900\\/60:is(.dark *) {
  background-color: rgb(120 53 15 / 0.6);
}
.dark\\:bg-blue-500\\/10:is(.dark *) {
  background-color: rgb(59 130 246 / 0.1);
}
.dark\\:bg-emerald-500\\/10:is(.dark *) {
  background-color: rgb(16 185 129 / 0.1);
}
.dark\\:bg-emerald-500\\/15:is(.dark *) {
  background-color: rgb(16 185 129 / 0.15);
}
.dark\\:bg-emerald-500\\/5:is(.dark *) {
  background-color: rgb(16 185 129 / 0.05);
}
.dark\\:bg-emerald-500\\/\\[0\\.06\\]:is(.dark *) {
  background-color: rgb(16 185 129 / 0.06);
}
.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.dark\\:bg-gray-700\\/50:is(.dark *) {
  background-color: rgb(55 65 81 / 0.5);
}
.dark\\:bg-gray-700\\/60:is(.dark *) {
  background-color: rgb(55 65 81 / 0.6);
}
.dark\\:bg-gray-700\\/70:is(.dark *) {
  background-color: rgb(55 65 81 / 0.7);
}
.dark\\:bg-gray-700\\/80:is(.dark *) {
  background-color: rgb(55 65 81 / 0.8);
}
.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.dark\\:bg-gray-800\\/60:is(.dark *) {
  background-color: rgb(31 41 55 / 0.6);
}
.dark\\:bg-gray-800\\/90:is(.dark *) {
  background-color: rgb(31 41 55 / 0.9);
}
.dark\\:bg-gray-800\\/95:is(.dark *) {
  background-color: rgb(31 41 55 / 0.95);
}
.dark\\:bg-gray-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.dark\\:bg-gray-900\\/30:is(.dark *) {
  background-color: rgb(17 24 39 / 0.3);
}
.dark\\:bg-gray-900\\/40:is(.dark *) {
  background-color: rgb(17 24 39 / 0.4);
}
.dark\\:bg-gray-900\\/50:is(.dark *) {
  background-color: rgb(17 24 39 / 0.5);
}
.dark\\:bg-gray-900\\/80:is(.dark *) {
  background-color: rgb(17 24 39 / 0.8);
}
.dark\\:bg-gray-900\\/90:is(.dark *) {
  background-color: rgb(17 24 39 / 0.9);
}
.dark\\:bg-gray-900\\/95:is(.dark *) {
  background-color: rgb(17 24 39 / 0.95);
}
.dark\\:bg-gray-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}
.dark\\:bg-lime-900\\/40:is(.dark *) {
  background-color: rgb(54 83 20 / 0.4);
}
.dark\\:bg-lime-900\\/50:is(.dark *) {
  background-color: rgb(54 83 20 / 0.5);
}
.dark\\:bg-lime-950\\/20:is(.dark *) {
  background-color: rgb(26 46 5 / 0.2);
}
.dark\\:bg-orange-500\\/10:is(.dark *) {
  background-color: rgb(249 115 22 / 0.1);
}
.dark\\:bg-orange-900\\/20:is(.dark *) {
  background-color: rgb(124 45 18 / 0.2);
}
.dark\\:bg-purple-500\\/10:is(.dark *) {
  background-color: rgb(168 85 247 / 0.1);
}
.dark\\:bg-red-500\\/10:is(.dark *) {
  background-color: rgb(239 68 68 / 0.1);
}
.dark\\:bg-red-900\\/10:is(.dark *) {
  background-color: rgb(127 29 29 / 0.1);
}
.dark\\:bg-red-900\\/20:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}
.dark\\:bg-red-950\\/20:is(.dark *) {
  background-color: rgb(69 10 10 / 0.2);
}
.dark\\:bg-red-950\\/40:is(.dark *) {
  background-color: rgb(69 10 10 / 0.4);
}
.dark\\:bg-white:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.dark\\:bg-white\\/10:is(.dark *) {
  background-color: rgb(255 255 255 / 0.1);
}
.dark\\:bg-white\\/5:is(.dark *) {
  background-color: rgb(255 255 255 / 0.05);
}
.dark\\:bg-yellow-500\\/10:is(.dark *) {
  background-color: rgb(234 179 8 / 0.1);
}
.dark\\:bg-\\[radial-gradient\\(circle_at_center\\2c _\\#1e293b_1px\\2c _transparent_1px\\)\\]:is(.dark *) {
  background-image: radial-gradient(circle at center, #1e293b 1px, transparent 1px);
}
.dark\\:fill-\\[\\#1e1e1e\\]:is(.dark *) {
  fill: #1e1e1e;
}
.dark\\:fill-\\[\\#39ff88\\]:is(.dark *) {
  fill: #39ff88;
}
.dark\\:fill-\\[\\#39ff88\\]\\/15:is(.dark *) {
  fill: rgb(57 255 136 / 0.15);
}
.dark\\:fill-\\[\\#39ff88\\]\\/50:is(.dark *) {
  fill: rgb(57 255 136 / 0.5);
}
.dark\\:fill-emerald-900\\/30:is(.dark *) {
  fill: rgb(6 78 59 / 0.3);
}
.dark\\:fill-gray-900:is(.dark *) {
  fill: #111827;
}
.dark\\:fill-neutral-600:is(.dark *) {
  fill: #525252;
}
.dark\\:fill-neutral-700:is(.dark *) {
  fill: #404040;
}
.dark\\:fill-white\\/5:is(.dark *) {
  fill: rgb(255 255 255 / 0.05);
}
.dark\\:stroke-\\[\\#39ff88\\]:is(.dark *) {
  stroke: #39ff88;
}
.dark\\:stroke-neutral-500:is(.dark *) {
  stroke: #737373;
}
.dark\\:stroke-neutral-600:is(.dark *) {
  stroke: #525252;
}
.dark\\:\\!text-amber-300:is(.dark *) {
  --tw-text-opacity: 1 !important;
  color: rgb(252 211 77 / var(--tw-text-opacity)) !important;
}
.dark\\:\\!text-emerald-300:is(.dark *) {
  --tw-text-opacity: 1 !important;
  color: rgb(110 231 183 / var(--tw-text-opacity)) !important;
}
.dark\\:\\!text-red-300:is(.dark *) {
  --tw-text-opacity: 1 !important;
  color: rgb(252 165 165 / var(--tw-text-opacity)) !important;
}
.dark\\:text-\\[\\#39ff88\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(57 255 136 / var(--tw-text-opacity));
}
.dark\\:text-amber-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity));
}
.dark\\:text-amber-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity));
}
.dark\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity));
}
.dark\\:text-emerald-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity));
}
.dark\\:text-emerald-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.dark\\:text-gray-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.dark\\:text-gray-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.dark\\:text-gray-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.dark\\:text-gray-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.dark\\:text-red-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}
.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.dark\\:shadow-none:is(.dark *) {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:shadow-black\\/50:is(.dark *) {
  --tw-shadow-color: rgb(0 0 0 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.dark\\:hover\\:border-gray-700:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}
.dark\\:hover\\:bg-emerald-500\\/10:hover:is(.dark *) {
  background-color: rgb(16 185 129 / 0.1);
}
.dark\\:hover\\:bg-emerald-500\\/15:hover:is(.dark *) {
  background-color: rgb(16 185 129 / 0.15);
}
.dark\\:hover\\:bg-gray-600\\/70:hover:is(.dark *) {
  background-color: rgb(75 85 99 / 0.7);
}
.dark\\:hover\\:bg-gray-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.dark\\:hover\\:bg-gray-700\\/60:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.6);
}
.dark\\:hover\\:bg-gray-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.dark\\:hover\\:bg-red-500\\/10:hover:is(.dark *) {
  background-color: rgb(239 68 68 / 0.1);
}
.dark\\:hover\\:bg-red-900\\/20:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}
.dark\\:hover\\:bg-red-900\\/40:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.4);
}
.dark\\:hover\\:bg-white\\/10:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.1);
}
.dark\\:hover\\:bg-white\\/\\[0\\.03\\]:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.03);
}
.dark\\:hover\\:text-emerald-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.dark\\:focus\\:border-emerald-700:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / var(--tw-border-opacity));
}
@media not all and (min-width: 640px) {

  .max-sm\\:\\!w-full {
    width: 100% !important;
  }
}
@media (min-width: 380px) {

  .min-\\[380px\\]\\:flex-row {
    flex-direction: row;
  }

  .min-\\[380px\\]\\:gap-5 {
    gap: 1.25rem;
  }

  .min-\\[380px\\]\\:gap-6 {
    gap: 1.5rem;
  }
}
@media (min-width: 400px) {

  .min-\\[400px\\]\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 640px) {

  .sm\\:absolute {
    position: absolute;
  }

  .sm\\:inset-4 {
    inset: 1rem;
  }

  .sm\\:inset-x-auto {
    left: auto;
    right: auto;
  }

  .sm\\:inset-y-0 {
    top: 0px;
    bottom: 0px;
  }

  .sm\\:bottom-7 {
    bottom: 1.75rem;
  }

  .sm\\:end-0 {
    inset-inline-end: 0px;
  }

  .sm\\:end-4 {
    inset-inline-end: 1rem;
  }

  .sm\\:end-6 {
    inset-inline-end: 1.5rem;
  }

  .sm\\:end-7 {
    inset-inline-end: 1.75rem;
  }

  .sm\\:end-auto {
    inset-inline-end: auto;
  }

  .sm\\:left-0 {
    left: 0px;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:right-auto {
    right: auto;
  }

  .sm\\:start-0 {
    inset-inline-start: 0px;
  }

  .sm\\:start-1\\/2 {
    inset-inline-start: 50%;
  }

  .sm\\:start-2 {
    inset-inline-start: 0.5rem;
  }

  .sm\\:start-7 {
    inset-inline-start: 1.75rem;
  }

  .sm\\:top-2 {
    top: 0.5rem;
  }

  .sm\\:top-4 {
    top: 1rem;
  }

  .sm\\:top-7 {
    top: 1.75rem;
  }

  .sm\\:top-\\[4px\\] {
    top: 4px;
  }

  .sm\\:top-\\[5px\\] {
    top: 5px;
  }

  .sm\\:top-full {
    top: 100%;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .sm\\:my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .sm\\:-mt-20 {
    margin-top: -5rem;
  }

  .sm\\:-mt-24 {
    margin-top: -6rem;
  }

  .sm\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .sm\\:mb-14 {
    margin-bottom: 3.5rem;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:mb-8 {
    margin-bottom: 2rem;
  }

  .sm\\:ms-0 {
    margin-inline-start: 0px;
  }

  .sm\\:mt-0\\.5 {
    margin-top: 0.125rem;
  }

  .sm\\:mt-10 {
    margin-top: 2.5rem;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:mt-3 {
    margin-top: 0.75rem;
  }

  .sm\\:line-clamp-3 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:inline-flex {
    display: inline-flex;
  }

  .sm\\:grid {
    display: grid;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:aspect-\\[4\\/5\\] {
    aspect-ratio: 4/5;
  }

  .sm\\:h-1\\.5 {
    height: 0.375rem;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-11 {
    height: 2.75rem;
  }

  .sm\\:h-12 {
    height: 3rem;
  }

  .sm\\:h-14 {
    height: 3.5rem;
  }

  .sm\\:h-16 {
    height: 4rem;
  }

  .sm\\:h-20 {
    height: 5rem;
  }

  .sm\\:h-24 {
    height: 6rem;
  }

  .sm\\:h-28 {
    height: 7rem;
  }

  .sm\\:h-32 {
    height: 8rem;
  }

  .sm\\:h-36 {
    height: 9rem;
  }

  .sm\\:h-4 {
    height: 1rem;
  }

  .sm\\:h-40 {
    height: 10rem;
  }

  .sm\\:h-44 {
    height: 11rem;
  }

  .sm\\:h-48 {
    height: 12rem;
  }

  .sm\\:h-5 {
    height: 1.25rem;
  }

  .sm\\:h-56 {
    height: 14rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-7 {
    height: 1.75rem;
  }

  .sm\\:h-72 {
    height: 18rem;
  }

  .sm\\:h-9 {
    height: 2.25rem;
  }

  .sm\\:h-\\[28rem\\] {
    height: 28rem;
  }

  .sm\\:h-\\[380px\\] {
    height: 380px;
  }

  .sm\\:h-\\[3px\\] {
    height: 3px;
  }

  .sm\\:h-\\[420px\\] {
    height: 420px;
  }

  .sm\\:h-\\[460px\\] {
    height: 460px;
  }

  .sm\\:h-\\[480px\\] {
    height: 480px;
  }

  .sm\\:h-\\[85vh\\] {
    height: 85vh;
  }

  .sm\\:max-h-52 {
    max-height: 13rem;
  }

  .sm\\:max-h-none {
    max-height: none;
  }

  .sm\\:min-h-0 {
    min-height: 0px;
  }

  .sm\\:min-h-\\[13rem\\] {
    min-height: 13rem;
  }

  .sm\\:min-h-\\[2\\.6rem\\] {
    min-height: 2.6rem;
  }

  .sm\\:min-h-\\[200px\\] {
    min-height: 200px;
  }

  .sm\\:min-h-\\[230px\\] {
    min-height: 230px;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-11 {
    width: 2.75rem;
  }

  .sm\\:w-12 {
    width: 3rem;
  }

  .sm\\:w-14 {
    width: 3.5rem;
  }

  .sm\\:w-16 {
    width: 4rem;
  }

  .sm\\:w-20 {
    width: 5rem;
  }

  .sm\\:w-24 {
    width: 6rem;
  }

  .sm\\:w-28 {
    width: 7rem;
  }

  .sm\\:w-32 {
    width: 8rem;
  }

  .sm\\:w-36 {
    width: 9rem;
  }

  .sm\\:w-4 {
    width: 1rem;
  }

  .sm\\:w-40 {
    width: 10rem;
  }

  .sm\\:w-44 {
    width: 11rem;
  }

  .sm\\:w-48 {
    width: 12rem;
  }

  .sm\\:w-5 {
    width: 1.25rem;
  }

  .sm\\:w-52 {
    width: 13rem;
  }

  .sm\\:w-56 {
    width: 14rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-64 {
    width: 16rem;
  }

  .sm\\:w-7 {
    width: 1.75rem;
  }

  .sm\\:w-72 {
    width: 18rem;
  }

  .sm\\:w-80 {
    width: 20rem;
  }

  .sm\\:w-9 {
    width: 2.25rem;
  }

  .sm\\:w-96 {
    width: 24rem;
  }

  .sm\\:w-\\[220px\\] {
    width: 220px;
  }

  .sm\\:w-\\[22rem\\] {
    width: 22rem;
  }

  .sm\\:w-\\[23rem\\] {
    width: 23rem;
  }

  .sm\\:w-\\[250px\\] {
    width: 250px;
  }

  .sm\\:w-\\[25rem\\] {
    width: 25rem;
  }

  .sm\\:w-\\[340px\\] {
    width: 340px;
  }

  .sm\\:w-\\[360px\\] {
    width: 360px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:min-w-\\[200px\\] {
    min-width: 200px;
  }

  .sm\\:min-w-\\[9rem\\] {
    min-width: 9rem;
  }

  .sm\\:max-w-2xl {
    max-width: 42rem;
  }

  .sm\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .sm\\:max-w-\\[88\\%\\] {
    max-width: 88%;
  }

  .sm\\:max-w-\\[90vw\\] {
    max-width: 90vw;
  }

  .sm\\:max-w-lg {
    max-width: 32rem;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:flex-none {
    flex: none;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[1\\.6fr_1fr_1\\.6fr_0\\.8fr\\] {
    grid-template-columns: 1.6fr 1fr 1.6fr 0.8fr;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-1 {
    gap: 0.25rem;
  }

  .sm\\:gap-1\\.5 {
    gap: 0.375rem;
  }

  .sm\\:gap-12 {
    gap: 3rem;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:gap-8 {
    gap: 2rem;
  }

  .sm\\:gap-y-0 {
    row-gap: 0px;
  }

  .sm\\:space-y-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }

  .sm\\:self-end {
    align-self: flex-end;
  }

  .sm\\:\\!rounded-2xl {
    border-radius: 1rem !important;
  }

  .sm\\:\\!rounded-3xl {
    border-radius: 1.5rem !important;
  }

  .sm\\:rounded-2xl {
    border-radius: 1rem;
  }

  .sm\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .sm\\:rounded-\\[2rem\\] {
    border-radius: 2rem;
  }

  .sm\\:rounded-\\[3rem\\] {
    border-radius: 3rem;
  }

  .sm\\:rounded-none {
    border-radius: 0px;
  }

  .sm\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .sm\\:border-\\[3px\\] {
    border-width: 3px;
  }

  .sm\\:border-x-0 {
    border-left-width: 0px;
    border-right-width: 0px;
  }

  .sm\\:border-y-2 {
    border-top-width: 2px;
    border-bottom-width: 2px;
  }

  .sm\\:border-e-\\[3px\\] {
    border-inline-end-width: 3px;
  }

  .sm\\:border-t-0 {
    border-top-width: 0px;
  }

  .sm\\:p-10 {
    padding: 2.5rem;
  }

  .sm\\:p-12 {
    padding: 3rem;
  }

  .sm\\:p-2\\.5 {
    padding: 0.625rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-3\\.5 {
    padding: 0.875rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-7 {
    padding: 1.75rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:\\!px-5 {
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }

  .sm\\:\\!py-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-0\\.5 {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .sm\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-14 {
    padding-bottom: 3.5rem;
  }

  .sm\\:pb-16 {
    padding-bottom: 4rem;
  }

  .sm\\:pb-24 {
    padding-bottom: 6rem;
  }

  .sm\\:pb-32 {
    padding-bottom: 8rem;
  }

  .sm\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .sm\\:pb-9 {
    padding-bottom: 2.25rem;
  }

  .sm\\:pb-\\[max\\(1\\.25rem\\2c env\\(safe-area-inset-bottom\\)\\)\\] {
    padding-bottom: max(1.25rem,env(safe-area-inset-bottom));
  }

  .sm\\:pe-6 {
    padding-inline-end: 1.5rem;
  }

  .sm\\:pe-7 {
    padding-inline-end: 1.75rem;
  }

  .sm\\:ps-11 {
    padding-inline-start: 2.75rem;
  }

  .sm\\:ps-5 {
    padding-inline-start: 1.25rem;
  }

  .sm\\:pt-10 {
    padding-top: 2.5rem;
  }

  .sm\\:pt-12 {
    padding-top: 3rem;
  }

  .sm\\:pt-14 {
    padding-top: 3.5rem;
  }

  .sm\\:pt-16 {
    padding-top: 4rem;
  }

  .sm\\:pt-28 {
    padding-top: 7rem;
  }

  .sm\\:pt-32 {
    padding-top: 8rem;
  }

  .sm\\:pt-44 {
    padding-top: 11rem;
  }

  .sm\\:pt-6 {
    padding-top: 1.5rem;
  }

  .sm\\:pt-7 {
    padding-top: 1.75rem;
  }

  .sm\\:pt-8 {
    padding-top: 2rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-center {
    text-align: center;
  }

  .sm\\:text-start {
    text-align: start;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-\\[11px\\] {
    font-size: 11px;
  }

  .sm\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .sm\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .sm\\:text-\\[8px\\] {
    font-size: 8px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:leading-7 {
    line-height: 1.75rem;
  }

  .sm\\:opacity-0 {
    opacity: 0;
  }

  .sm\\:\\[box-shadow\\:calc\\(var\\(--dx\\)\\*5px\\)_5px_0_0_var\\(--sh\\)\\] {
    box-shadow: calc(var(--dx) * 5px) 5px 0 0 var(--sh);
  }

  .sm\\:\\[box-shadow\\:calc\\(var\\(--dx\\)\\*6px\\)_6px_0_0_var\\(--svc-sh\\)\\] {
    box-shadow: calc(var(--dx) * 6px) 6px 0 0 var(--svc-sh);
  }

  .group:hover .sm\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
}
@media (min-width: 720px) {

  .min-\\[720px\\]\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 768px) {

  .md\\:sticky {
    position: sticky;
  }

  .md\\:top-28 {
    top: 7rem;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:table-cell {
    display: table-cell;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-24 {
    height: 6rem;
  }

  .md\\:w-72 {
    width: 18rem;
  }

  .md\\:w-96 {
    width: 24rem;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:border-e-2 {
    border-inline-end-width: 2px;
  }

  .md\\:pb-14 {
    padding-bottom: 3.5rem;
  }

  .md\\:pe-3 {
    padding-inline-end: 0.75rem;
  }

  .md\\:pe-4 {
    padding-inline-end: 1rem;
  }

  .md\\:pr-4 {
    padding-right: 1rem;
  }

  .md\\:pt-32 {
    padding-top: 8rem;
  }

  .md\\:pt-36 {
    padding-top: 9rem;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:opacity-0 {
    opacity: 0;
  }

  .md\\:focus-visible\\:opacity-100:focus-visible {
    opacity: 1;
  }

  .group:hover .md\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
}
@media (min-width: 1024px) {

  .lg\\:visible {
    visibility: visible;
  }

  .lg\\:sticky {
    position: sticky;
  }

  .lg\\:bottom-8 {
    bottom: 2rem;
  }

  .lg\\:end-16 {
    inset-inline-end: 4rem;
  }

  .lg\\:end-8 {
    inset-inline-end: 2rem;
  }

  .lg\\:left-64 {
    left: 16rem;
  }

  .lg\\:start-64 {
    inset-inline-start: 16rem;
  }

  .lg\\:top-28 {
    top: 7rem;
  }

  .lg\\:top-32 {
    top: 8rem;
  }

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:inline-block {
    display: inline-block;
  }

  .lg\\:inline {
    display: inline;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-20 {
    height: 5rem;
  }

  .lg\\:h-24 {
    height: 6rem;
  }

  .lg\\:h-32 {
    height: 8rem;
  }

  .lg\\:h-36 {
    height: 9rem;
  }

  .lg\\:h-44 {
    height: 11rem;
  }

  .lg\\:h-\\[4\\.5rem\\] {
    height: 4.5rem;
  }

  .lg\\:h-\\[520px\\] {
    height: 520px;
  }

  .lg\\:h-\\[560px\\] {
    height: 560px;
  }

  .lg\\:max-h-\\[40rem\\] {
    max-height: 40rem;
  }

  .lg\\:max-h-\\[560px\\] {
    max-height: 560px;
  }

  .lg\\:w-2\\/3 {
    width: 66.666667%;
  }

  .lg\\:w-20 {
    width: 5rem;
  }

  .lg\\:w-32 {
    width: 8rem;
  }

  .lg\\:w-36 {
    width: 9rem;
  }

  .lg\\:w-44 {
    width: 11rem;
  }

  .lg\\:w-52 {
    width: 13rem;
  }

  .lg\\:w-56 {
    width: 14rem;
  }

  .lg\\:w-72 {
    width: 18rem;
  }

  .lg\\:w-80 {
    width: 20rem;
  }

  .lg\\:w-\\[24rem\\] {
    width: 24rem;
  }

  .lg\\:w-\\[26rem\\] {
    width: 26rem;
  }

  .lg\\:w-\\[4\\.5rem\\] {
    width: 4.5rem;
  }

  .lg\\:w-\\[5\\.75rem\\] {
    width: 5.75rem;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:min-w-0 {
    min-width: 0px;
  }

  .lg\\:max-w-md {
    max-width: 28rem;
  }

  .lg\\:flex-1 {
    flex: 1 1;
  }

  .lg\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[16rem_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 16rem minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[20rem_1fr\\] {
    grid-template-columns: 20rem 1fr;
  }

  .lg\\:grid-cols-\\[360px_1fr\\] {
    grid-template-columns: 360px 1fr;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_18rem\\] {
    grid-template-columns: minmax(0,1fr) 18rem;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_21rem\\] {
    grid-template-columns: minmax(0,1fr) 21rem;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_22rem\\] {
    grid-template-columns: minmax(0,1fr) 22rem;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-12 {
    gap: 3rem;
  }

  .lg\\:gap-14 {
    gap: 3.5rem;
  }

  .lg\\:gap-5 {
    gap: 1.25rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:overflow-visible {
    overflow: visible;
  }

  .lg\\:overflow-y-auto {
    overflow-y: auto;
  }

  .lg\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .lg\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .lg\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .lg\\:border-e {
    border-inline-end-width: 1px;
  }

  .lg\\:border-gray-100 {
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity));
  }

  .lg\\:border-gray-800 {
    --tw-border-opacity: 1;
    border-color: rgb(31 41 55 / var(--tw-border-opacity));
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:pb-1\\.5 {
    padding-bottom: 0.375rem;
  }

  .lg\\:pb-16 {
    padding-bottom: 4rem;
  }

  .lg\\:pl-64 {
    padding-left: 16rem;
  }

  .lg\\:pl-\\[272px\\] {
    padding-left: 272px;
  }

  .lg\\:pr-\\[17rem\\] {
    padding-right: 17rem;
  }

  .lg\\:ps-64 {
    padding-inline-start: 16rem;
  }

  .lg\\:pt-28 {
    padding-top: 7rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-\\[2rem\\] {
    font-size: 2rem;
  }

  .lg\\:text-\\[4\\.25rem\\] {
    font-size: 4.25rem;
  }

  .lg\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media (min-width: 1280px) {

  .xl\\:end-16 {
    inset-inline-end: 4rem;
  }

  .xl\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:inline {
    display: inline;
  }

  .xl\\:h-60 {
    height: 15rem;
  }

  .xl\\:w-60 {
    width: 15rem;
  }

  .xl\\:w-96 {
    width: 24rem;
  }

  .xl\\:w-\\[19rem\\] {
    width: 19rem;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[22rem_1fr\\] {
    grid-template-columns: 22rem 1fr;
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_20rem\\] {
    grid-template-columns: minmax(0,1fr) 20rem;
  }

  .xl\\:gap-4 {
    gap: 1rem;
  }
}
.ltr\\:-translate-x-1\\/2:where([dir="ltr"], [dir="ltr"] *) {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ltr\\:-translate-x-2:where([dir="ltr"], [dir="ltr"] *) {
  --tw-translate-x: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ltr\\:translate-x-5:where([dir="ltr"], [dir="ltr"] *) {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ltr\\:rotate-180:where([dir="ltr"], [dir="ltr"] *) {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:origin-right:where([dir="rtl"], [dir="rtl"] *) {
  transform-origin: right;
}
.rtl\\:-translate-x-5:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:-translate-x-9:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: -2.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:-translate-x-\\[26px\\]:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: -26px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:translate-x-1\\/2:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:translate-x-2:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:translate-x-full:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:-scale-x-100:where([dir="rtl"], [dir="rtl"] *) {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:flex-row:where([dir="rtl"], [dir="rtl"] *) {
  flex-direction: row;
}
.rtl\\:flex-row-reverse:where([dir="rtl"], [dir="rtl"] *) {
  flex-direction: row-reverse;
}
.rtl\\:bg-gradient-to-l:where([dir="rtl"], [dir="rtl"] *) {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.rtl\\:text-end:where([dir="rtl"], [dir="rtl"] *) {
  text-align: end;
}
.rtl\\:not-italic:where([dir="rtl"], [dir="rtl"] *) {
  font-style: normal;
}
.rtl\\:leading-\\[1\\.4\\]:where([dir="rtl"], [dir="rtl"] *) {
  line-height: 1.4;
}
.rtl\\:leading-snug:where([dir="rtl"], [dir="rtl"] *) {
  line-height: 1.375;
}
.rtl\\:tracking-normal:where([dir="rtl"], [dir="rtl"] *) {
  letter-spacing: 0em;
}
.rtl\\:\\[--dx\\:-1\\]:where([dir="rtl"], [dir="rtl"] *) {
  --dx: -1;
}
@media (min-width: 1024px) {

  .lg\\:rtl\\:translate-x-0:where([dir="rtl"], [dir="rtl"] *) {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}
.\\[\\&\\:\\:-webkit-search-cancel-button\\]\\:hidden::-webkit-search-cancel-button {
  display: none;
}
.\\[\\&\\:\\:-webkit-search-cancel-button\\]\\:appearance-none::-webkit-search-cancel-button {
  appearance: none;
}
.\\[\\&\\:\\:-webkit-search-decoration\\]\\:hidden::-webkit-search-decoration {
  display: none;
}
@media(hover:hover) {

  .\\[\\@media\\(hover\\:hover\\)\\]\\:flex {
    display: flex;
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:opacity-0 {
    opacity: 0;
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:-translate-y-0\\.5:hover {
    --tw-translate-y: -0.125rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:-translate-y-1:hover {
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:-translate-y-px:hover {
    --tw-translate-y: -1px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:border-\\[\\#39ff88\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(57 255 136 / var(--tw-border-opacity));
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:border-\\[color\\:var\\(--acc\\)\\]:hover {
    border-color: var(--acc);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:border-emerald-400\\/60:hover {
    border-color: rgb(52 211 153 / 0.6);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:border-emerald-500\\/60:hover {
    border-color: rgb(16 185 129 / 0.6);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:bg-\\[color\\:var\\(--card-hi\\)\\]:hover {
    background-color: var(--card-hi);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:bg-emerald-50\\/40:hover {
    background-color: rgb(236 253 245 / 0.4);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:from-emerald-400:hover {
    --tw-gradient-from: #34d399 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:to-emerald-600:hover {
    --tw-gradient-to: #059669 var(--tw-gradient-to-position);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:shadow-2xl:hover {
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:shadow-\\[0_12px_24px_-10px_var\\(--acc\\)\\]:hover {
    --tw-shadow: 0 12px 24px -10px var(--acc);
    --tw-shadow-colored: 0 12px 24px -10px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c \\.3\\)\\2c 0_12px_20px_-8px_rgba\\(5\\2c 150\\2c 105\\2c \\.9\\)\\]:hover {
    --tw-shadow: inset 0 1px 0 rgba(255,255,255,.3),0 12px 20px -8px rgba(5,150,105,.9);
    --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 12px 20px -8px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:shadow-xl:hover {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:shadow-black\\/10:hover {
    --tw-shadow-color: rgb(0 0 0 / 0.1);
    --tw-shadow: var(--tw-shadow-colored);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:shadow-black\\/25:hover {
    --tw-shadow-color: rgb(0 0 0 / 0.25);
    --tw-shadow: var(--tw-shadow-colored);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:\\[box-shadow\\:calc\\(var\\(--dx\\)\\*5px\\)_6px_0_0_var\\(--sh\\)\\]:hover {
    box-shadow: calc(var(--dx) * 5px) 6px 0 0 var(--sh);
  }

  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:\\[box-shadow\\:calc\\(var\\(--dx\\)\\*8px\\)_10px_0_0_var\\(--sh\\)\\]:hover {
    box-shadow: calc(var(--dx) * 8px) 10px 0 0 var(--sh);
  }

  .group:hover .\\[\\@media\\(hover\\:hover\\)\\]\\:group-hover\\:-translate-y-1 {
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group:hover .\\[\\@media\\(hover\\:hover\\)\\]\\:group-hover\\:-translate-y-1\\.5 {
    --tw-translate-y: -0.375rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group:hover .\\[\\@media\\(hover\\:hover\\)\\]\\:group-hover\\:translate-x-1 {
    --tw-translate-x: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group:hover .\\[\\@media\\(hover\\:hover\\)\\]\\:group-hover\\:translate-y-0 {
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group:hover .\\[\\@media\\(hover\\:hover\\)\\]\\:group-hover\\:-rotate-6 {
    --tw-rotate: -6deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group:hover .\\[\\@media\\(hover\\:hover\\)\\]\\:group-hover\\:scale-105 {
    --tw-scale-x: 1.05;
    --tw-scale-y: 1.05;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group:hover .\\[\\@media\\(hover\\:hover\\)\\]\\:group-hover\\:scale-110 {
    --tw-scale-x: 1.1;
    --tw-scale-y: 1.1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group:hover .\\[\\@media\\(hover\\:hover\\)\\]\\:group-hover\\:opacity-100 {
    opacity: 1;
  }

  .group:hover .\\[\\@media\\(hover\\:hover\\)\\]\\:group-hover\\:shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .group:focus-visible .\\[\\@media\\(hover\\:hover\\)\\]\\:group-focus-visible\\:opacity-100 {
    opacity: 1;
  }

  .group:hover .rtl\\:\\[\\@media\\(hover\\:hover\\)\\]\\:group-hover\\:-translate-x-1:where([dir="rtl"], [dir="rtl"] *) {
    --tw-translate-x: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,6CAAc;EAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,kEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kEAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+DAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oFAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAkBnB;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,sBAAsB;;AAExB;;;;AAIA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;AACA,iBAAiB,wCAAwC,EAAE;AAC3D,uBAAuB,qBAAqB,EAAE;AAC9C,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,qBAAqB,EAAE;AAC/C,qBAAqB;AACrB;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB,EAAE,sBAAsB;EAC3C,mBAAmB;AACrB;AACA;EACE,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA,YAAY;AACZ;EACE,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,yCAAyC,EAAE;AACnD;AACA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,0CAA0C,EAAE;AACpD;AACA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;AACA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;AACA;EACE,WAAW,qDAAqD,EAAE;EAClE,MAAM,2DAA2D,EAAE;AACrE;AACA;EACE,WAAW,sDAAsD,EAAE;EACnE,MAAM,0DAA0D,EAAE;AACpE;AACA;EACE,WAAW,sDAAsD,EAAE;EACnE,MAAM,4DAA4D,EAAE;AACtE;AACA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;AACA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,sBAAsB,6CAA6C,EAAE;AACrE,wBAAwB,+CAA+C,EAAE;AACzE,sBAAsB,6CAA6C,EAAE;AACrE,qBAAqB,wCAAwC,EAAE;AAC/D,oBAAoB,2CAA2C,EAAE;AACjE,0BAA0B,oDAAoD,EAAE;AAChF,yBAAyB,gDAAgD,EAAE;AAC3E,mBAAmB,yCAAyC,EAAE,UAAU,EAAE;AAC1E,kBAAkB,+BAA+B,EAAE;;AAEnD,oBAAoB,mBAAmB,EAAE;AACzC,eAAe,yBAAyB,EAAE;AAC1C,gBAAgB,0BAA0B,EAAE;AAC5C,eAAe,yBAAyB,EAAE;AAC1C,cAAc,wBAAwB,EAAE;AACxC,cAAc,wBAAwB,EAAE;AACxC,eAAe,yBAAyB,EAAE;;AAE1C,qCAAqC,aAAa,EAAE;AACpD,kBAAkB,wBAAwB,EAAE,qBAAqB,EAAE;AAjInE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,2CAiIoE;EAjIpE,qDAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,+EAiIoE;EAjIpE,mGAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,qCAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,2GAiIoE;EAjIpE,yGAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,2BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,iBAiIoE;EAjIpE,iBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,4DAiIoE;EAjIpE,qEAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,4DAiIoE;EAjIpE,qEAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,+BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,+EAiIoE;EAjIpE,mGAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,6EAiIoE;EAjIpE,iGAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,mCAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,yCAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,iCAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,gCAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,gCAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,8BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,2GAiIoE;EAjIpE,yGAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,2GAiIoE;EAjIpE,yGAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,8BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,2GAiIoE;EAjIpE,yGAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,2GAiIoE;EAjIpE,yGAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,uCAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,uCAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,uCAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,qBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,yBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,qBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,qBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,qBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,gBAiIoE;EAjIpE,gBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,iBAiIoE;EAjIpE,iBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,iBAiIoE;EAjIpE,iBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,iBAiIoE;EAjIpE,iBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,iBAiIoE;EAjIpE,iBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,8BAiIoE;EAjIpE,qDAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,8BAiIoE;EAjIpE,qDAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,8BAiIoE;EAjIpE,qDAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,8BAiIoE;EAjIpE,qDAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,8BAiIoE;EAjIpE,qDAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,8BAiIoE;EAjIpE,qDAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,8BAiIoE;EAjIpE,qDAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,8BAiIoE;EAjIpE,qDAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,qBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE,8BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,qBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,2BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,iBAiIoE;EAjIpE,iBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,gBAiIoE;EAjIpE,gBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,mBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;;EAAA;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;AAAA;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,6BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,+BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,+BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,+BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE,8BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,mCAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,kBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,oBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;;EAAA;IAAA;EAiIoE;AAAA;AAjIpE;;EAAA;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;AAAA;AAjIpE;;EAAA;IAAA;EAiIoE;AAAA;AAjIpE;;EAAA;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,UAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,QAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,oBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,gBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,mBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,gBAiIoE;IAjIpE,oBAiIoE;IAjIpE,4BAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,uBAiIoE;IAjIpE,4DAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,sBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,qBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,gCAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,4BAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,sBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,qBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,sBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,qBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,oBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,mBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,mBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,oBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,mBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,mBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,eAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,eAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,mBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,mBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;AAAA;AAjIpE;;EAAA;IAAA;EAiIoE;AAAA;AAjIpE;;EAAA;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,gBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;AAAA;AAjIpE;;EAAA;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,gBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,qBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,sBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,sBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,eAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,sBAiIoE;IAjIpE,8BAiIoE;IAjIpE;EAiIoE;AAAA;AAjIpE;;EAAA;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;AAAA;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,yBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,yBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,mBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,0BAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,uBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,qBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,wBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,sBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,mBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA,gBAiIoE;EAjIpE;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;;EAAA;IAAA,qBAiIoE;IAjIpE;EAiIoE;AAAA;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;EAAA;AAiIoE;AAjIpE;;EAAA;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,2BAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,0BAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,sBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,sBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,4DAiIoE;IAjIpE,oEAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,gDAiIoE;IAjIpE,6DAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,yCAiIoE;IAjIpE,6DAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,mFAiIoE;IAjIpE,kGAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,gFAiIoE;IAjIpE,oGAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,mCAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,oCAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,0BAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,2BAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,yBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,qBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,kBAiIoE;IAjIpE,kBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA,iBAiIoE;IAjIpE,iBAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,+EAiIoE;IAjIpE,mGAiIoE;IAjIpE;EAiIoE;;EAjIpE;IAAA;EAiIoE;;EAjIpE;IAAA,0BAiIoE;IAjIpE;EAiIoE;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n@import '@fontsource/poppins/100.css';\n@import '@fontsource/poppins/200.css';\n@import '@fontsource/poppins/300.css';\n@import '@fontsource/poppins/400.css';\n@import '@fontsource/poppins/500.css';\n@import '@fontsource/poppins/600.css';\n@import '@fontsource/poppins/700.css';\n@import '@fontsource/poppins/800.css';\n@import '@fontsource/poppins/900.css';\n\n@layer base {\n  html {\n    font-family: 'Poppins', system-ui, sans-serif;\n  }\n}\n::-webkit-scrollbar{\n  width: 6px;;\n}\n::-webkit-scrollbar-track{\n  background-color: #f1f1f1;\n}\n::-webkit-scrollbar-thumb{\n  background-color: #888;\n  border-radius: 5px;\n}\n::-webkit-scrollbar-thumb:hover{\n  background-color: #555;\n\n}\n\n\n\n.hide-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-20px); }\n}\n.animate-float { animation: float 6s ease-in-out infinite; }\n.animation-delay-500 { animation-delay: 0.5s; }\n.animation-delay-1000 { animation-delay: 1s; }\n.animation-delay-1500 { animation-delay: 1.5s; }\n/* Custom Scrollbar */\n.custom-scroll::-webkit-scrollbar {\n  height: 8px;\n}\n.custom-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n.custom-scroll::-webkit-scrollbar-thumb {\n  background: #3b82f6; /* Tailwind blue-500 */\n  border-radius: 10px;\n}\n.custom-scroll::-webkit-scrollbar-thumb:hover {\n  background: #2563eb; /* Tailwind blue-600 */\n}\n\n/* Firefox */\n.custom-scroll {\n  scrollbar-color: #3b82f6 transparent;\n  scrollbar-width: thin;\n}\n@keyframes float-slow {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  50% { transform: translateY(-20px) rotate(5deg); }\n}\n@keyframes float-medium {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  50% { transform: translateY(-15px) rotate(-3deg); }\n}\n@keyframes float-fast {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n@keyframes spin-slow {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n@keyframes float-3d {\n  0%, 100% { transform: translateY(0) rotateY(12deg) rotateX(6deg); }\n  50% { transform: translateY(-25px) rotateY(-12deg) rotateX(-6deg); }\n}\n@keyframes float-3d-delay {\n  0%, 100% { transform: translateY(0) rotateY(-15deg) rotateX(8deg); }\n  50% { transform: translateY(-20px) rotateY(15deg) rotateX(-8deg); }\n}\n@keyframes float-3d-fast {\n  0%, 100% { transform: translateY(0) rotateY(20deg) rotateX(10deg); }\n  50% { transform: translateY(-15px) rotateY(-20deg) rotateX(-10deg); }\n}\n@keyframes slideIn {\n  from { opacity: 0; transform: translateY(30px) scale(0.95); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.animate-float-slow { animation: float-slow 6s ease-in-out infinite; }\n.animate-float-medium { animation: float-medium 5s ease-in-out infinite; }\n.animate-float-fast { animation: float-fast 4s ease-in-out infinite; }\n.animate-spin-slow { animation: spin-slow 20s linear infinite; }\n.animate-float-3d { animation: float-3d 8s ease-in-out infinite; }\n.animate-float-3d-delay { animation: float-3d-delay 7s ease-in-out infinite 1s; }\n.animate-float-3d-fast { animation: float-3d-fast 5s ease-in-out infinite; }\n.animate-slideIn { animation: slideIn 0.5s ease-out forwards; opacity: 0; }\n.animate-fadeIn { animation: fadeIn 0.5s ease-out; }\n\n.perspective-1000 { perspective: 1000px; }\n.rotate-y-12 { transform: rotateY(12deg); }\n.rotate-y--15 { transform: rotateY(-15deg); }\n.rotate-y-20 { transform: rotateY(20deg); }\n.rotate-x-6 { transform: rotateX(6deg); }\n.rotate-x-8 { transform: rotateX(8deg); }\n.rotate-x-10 { transform: rotateX(10deg); }\n\n.hide-scrollbar::-webkit-scrollbar { display: none; }\n.hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
